let selectedVariantId = null;
const I9_HEADSET_QUOTE_CACHE_TTL_MS = 30000;
const I9_HEADSET_QUOTE_CACHE_MAX = 50;
const I9_HEADSET_VAT_CACHE_TTL_MS = 3600000;

function i9_get_headset_context() {
  const ctx = window.I9_HEADSET_CONTEXT;
  return (ctx && typeof ctx === 'object') ? ctx : {};
}

function i9_get_storefront_currency_code() {
  const ctx = i9_get_headset_context();
  return String(
    ctx.currency_code ||
    window?.Shopify?.currency?.active ||
    'USD'
  ).toUpperCase();
}

function i9_get_storefront_country_code() {
  const ctx = i9_get_headset_context();
  const raw = ctx.country_code || window?.Shopify?.country || '';
  return raw ? String(raw).toUpperCase() : '';
}

function i9_get_storefront_country_name() {
  const ctx = i9_get_headset_context();
  const raw = ctx.country_name || '';
  return raw ? String(raw) : '';
}

function i9_get_storefront_currency_rate() {
  const rate = Number(window?.Shopify?.currency?.rate);
  return Number.isFinite(rate) && rate > 0 ? rate : null;
}

function i9_normalize_price_tier(raw) {
  const v = String(raw || '').toLowerCase().replace(/[\s_-]+/g, '');
  if (['oem3', 'oemtier3'].includes(v)) return 'oem3';
  if (['oem2', 'oemtier2'].includes(v)) return 'oem2';
  if (['oem1', 'oemtier1'].includes(v)) return 'oem1';
  if (['wh2', 'wholesale2', 'tier2'].includes(v)) return 'wh2';
  if (['wh1', 'wholesale1', 'tier1', 'wholesale', 'wh'].includes(v)) return 'wh1';
  return 'retail';
}

function i9_get_active_price_tier() {
  const explicit = String(window?.I9_PRICE_TIER || '').trim().toLowerCase();
  if (explicit) return i9_normalize_price_tier(explicit);

  const tags = Array.isArray(i9CustomerTags) ? i9CustomerTags : [];
  const blob = tags.map(t => String(t || '').toLowerCase()).join(' ');
  if (/(^|[^a-z0-9])(oem|oe)[\s_-]*3([^a-z0-9]|$)/.test(blob)) return 'oem3';
  if (/(^|[^a-z0-9])(oem|oe)[\s_-]*2([^a-z0-9]|$)/.test(blob)) return 'oem2';
  if (/(^|[^a-z0-9])(oem|oe)[\s_-]*1([^a-z0-9]|$)/.test(blob)) return 'oem1';
  if (/(^|[^a-z0-9])(wholesale|dealer|wh|tier)[\s_-]*2([^a-z0-9]|$)/.test(blob)) return 'wh2';
  if (/(^|[^a-z0-9])(wholesale|dealer|wh|tier)[\s_-]*1([^a-z0-9]|$)/.test(blob)) return 'wh1';

  if (i9CustomerIsB2B && String(window?.I9_DEFAULT_B2B_TIER || '').trim() !== '') {
    return i9_normalize_price_tier(window.I9_DEFAULT_B2B_TIER);
  }
  return 'retail';
}

function i9_get_headset_shopper_context() {
  const tier = i9_get_active_price_tier();
  const currencyCode = i9_get_storefront_currency_code();
  const countryCode = i9_get_storefront_country_code();
  const countryName = i9_get_storefront_country_name();
  const fxRate = i9_get_storefront_currency_rate();
  const includeVat = (currencyCode === 'EUR' && tier === 'retail');
  return {
    response_scope: 'shopper',
    price_tier: tier,
    currency_code: currencyCode,
    country_code: countryCode,
    country_name: countryName,
    currency_rate: fxRate,
    display_vat_inclusive: includeVat ? 1 : 0
  };
}

function i9_format_price_for_currency(price, currencyCode) {
  const locale = currencyCode === 'EUR' ? 'de-DE' : (currencyCode === 'CAD' ? 'en-CA' : undefined);
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false
  }).format(price);
}

function i9_get_headset_price_nodes() {
  const nodes = Array.from(document.querySelectorAll('.f-price-item'));
  if (nodes.length > 0) return nodes;
  const regularNode = document.querySelector('[id^="Price"] .f-price-item--regular');
  return regularNode ? [regularNode] : [];
}

function i9_get_headset_price_host() {
  return document.querySelector('[id^="Price"]') || i9_get_headset_price_nodes()[0]?.parentElement || null;
}

function i9_ensure_headset_tax_note() {
  let note = document.getElementById('i9HeadsetTaxNote');
  if (note) return note;
  const host = i9_get_headset_price_host();
  if (!host) return null;
  note = document.createElement('p');
  note.id = 'i9HeadsetTaxNote';
  note.className = 'i9-headset-tax-note';
  note.hidden = true;
  host.insertAdjacentElement('afterend', note);
  return note;
}

function i9_release_headset_price_gate() {
  document.documentElement.classList.remove('i9-headset-price-pending');
}

function i9_format_vat_rate(value) {
  const rate = Number(value);
  if (!Number.isFinite(rate)) return '';
  return Number.isInteger(rate) ? String(rate) : String(rate).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
}

function i9_requires_final_headset_price() {
  const shopperContext = i9_get_headset_shopper_context();
  return (
    shopperContext.currency_code === 'EUR' &&
    shopperContext.price_tier === 'retail' &&
    shopperContext.display_vat_inclusive === 1
  );
}

function i9_apply_headset_vat_context(info) {
  const ctx = Object.assign({}, window.I9_HEADSET_CONTEXT || {});
  if (info && typeof info === 'object') {
    [
      'country_code',
      'country_name',
      'country_region',
      'vat_rate',
      'vat_source',
      'display_vat_inclusive',
      'vat_included',
      'notice'
    ].forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(info, key) && info[key] !== undefined && info[key] !== null && info[key] !== '') {
        ctx[key] = info[key];
      }
    });
    window.I9_HEADSET_CONTEXT = ctx;
  }

  const note = i9_ensure_headset_tax_note();
  if (!note) return;

  const shopperContext = i9_get_headset_shopper_context();
  const vatRate = Number(info?.vat_rate ?? ctx.vat_rate);
  const countryRegion = String(info?.country_region || ctx.country_region || '').toLowerCase();
  const vatIncluded = (info && typeof info.vat_included === 'boolean')
    ? info.vat_included
    : (
      shopperContext.currency_code === 'EUR' &&
      shopperContext.price_tier === 'retail' &&
      shopperContext.display_vat_inclusive === 1 &&
      countryRegion === 'eu' &&
      Number.isFinite(vatRate)
    );

  if (!vatIncluded || !Number.isFinite(vatRate)) {
    note.hidden = true;
    note.textContent = '';
    return;
  }

  const countryName = String(info?.country_name || ctx.country_name || '').trim();
  const notice = String(info?.notice || ctx.notice || '').trim();
  note.textContent = notice || `Price includes ${i9_format_vat_rate(vatRate)}% VAT${countryName ? ` for ${countryName}` : ''}.`;
  note.hidden = false;
}

function i9_set_headset_price_pending(isPending) {
  const strictFinalPrice = i9_requires_final_headset_price();
  document.documentElement.classList.toggle('i9-headset-price-pending', strictFinalPrice && isPending);
  i9_get_headset_price_nodes().forEach((el) => {
    if (isPending) {
      el.style.opacity = strictFinalPrice ? '0' : '0.6';
      el.style.visibility = strictFinalPrice ? 'hidden' : '';
      el.setAttribute('aria-busy', 'true');
      return;
    }
    el.style.opacity = '';
    el.style.visibility = '';
    el.removeAttribute('aria-busy');
  });

  const note = document.getElementById('i9HeadsetTaxNote');
  if (note && strictFinalPrice && isPending) {
    note.style.opacity = '0';
    note.hidden = true;
  } else if (note) {
    note.style.opacity = '';
  }
}

function i9_render_headset_price_value(price) {
  if (!Number.isFinite(price)) return;
  const priceText = i9_format_price_for_currency(Number(price), i9_get_storefront_currency_code());

  const regularNode = document.querySelector('[id^="Price"] .f-price-item--regular');
  if (regularNode) regularNode.textContent = priceText;
  document.querySelectorAll('.f-price-item').forEach((el) => {
    el.textContent = priceText;
  });
  i9_set_headset_price_pending(false);
}

document.addEventListener("DOMContentLoaded", function () {
  const styleOptionsByPosition = {
    both: ["ZS/ZS", "IS/IS", "EC/EC", "ZS/EC"],
    top: ["ZS", "IS", "EC"],
    bottom: ["ZS", "IS", "EC"]
  };
  const i9HeadsetQuoteCache = new Map();
  const i9HeadsetDisplayFactorCache = new Map();
  let i9HeadsetQuoteAbort = null;
  let i9HeadsetQuoteSeq = 0;
  let i9QuoteDebounceTimer = null;

  function getHeadsetVatInfoCacheKey() {
    const ctx = i9_get_headset_shopper_context();
    return JSON.stringify({
      price_tier: ctx.price_tier,
      currency_code: ctx.currency_code,
      country_code: ctx.country_code,
      country_name: ctx.country_name,
      display_vat_inclusive: ctx.display_vat_inclusive
    });
  }

  function getCachedHeadsetVatInfo(key) {
    if (!key || !window.sessionStorage) return null;
    try {
      const raw = window.sessionStorage.getItem(`i9_headset_vat:${key}`);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      if ((Date.now() - Number(parsed.ts || 0)) > I9_HEADSET_VAT_CACHE_TTL_MS) {
        window.sessionStorage.removeItem(`i9_headset_vat:${key}`);
        return null;
      }
      return parsed.data || null;
    } catch (_) {
      return null;
    }
  }

  function setCachedHeadsetVatInfo(key, data) {
    if (!key || !data || typeof data !== 'object' || !window.sessionStorage) return;
    try {
      window.sessionStorage.setItem(`i9_headset_vat:${key}`, JSON.stringify({
        ts: Date.now(),
        data
      }));
    } catch (_) {}
  }

  async function bootstrapHeadsetVatInfo() {
    const ctx = i9_get_headset_shopper_context();
    if (ctx.currency_code !== 'EUR' || ctx.price_tier !== 'retail') {
      i9_apply_headset_vat_context({ vat_included: false, display_vat_inclusive: ctx.display_vat_inclusive });
      return;
    }

    const key = getHeadsetVatInfoCacheKey();
    const cached = getCachedHeadsetVatInfo(key);
    if (cached) {
      i9_apply_headset_vat_context(cached);
      return;
    }

    const payload = {
      type: 'country_vat_info',
      response_scope: ctx.response_scope,
      price_tier: ctx.price_tier,
      currency_code: ctx.currency_code,
      country_code: ctx.country_code,
      country_name: ctx.country_name,
      display_vat_inclusive: ctx.display_vat_inclusive
    };
    if (ctx.currency_rate !== null) payload.currency_rate = ctx.currency_rate;
    if (window.I9_STORE) payload.store = window.I9_STORE;

    const base = (window.I9_API_BUILD_URL || window.I9_API_BASE || 'https://api.i9.bike').replace(/\/$/, '');
    try {
      const res = await fetch(`${base}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json().catch(() => null);
      if (!data || data.ok !== true) return;
      setCachedHeadsetVatInfo(key, data);
      i9_apply_headset_vat_context(data);
    } catch (err) {
      console.warn('Headset VAT bootstrap failed', err);
    }
  }

  function setupButtonGroupInteraction(groupName) {
    const group = document.querySelector(`[data-group="${groupName}"] .button-group`);
    const subtitle = document.querySelector(`[data-group="${groupName}"] .section-subtitle`);
    if (!group) return;

    group.addEventListener('click', e => {
      const btn = e.target.closest('.option-button');
      if (!btn) return;
      group.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      subtitle.textContent = btn.textContent.trim();
      if (groupName === 'upper headtube bore') updateSpecializedFrameSection();
      drawHeadsetToCanvas();
      updateSelectedVariantId();
    });
  }

  ['top cover height', 'upper headtube bore', 'lower headtube bore'].forEach(setupButtonGroupInteraction);

  function getSelectedHeadsetStyleSpecs() {
    const style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim() || '';
    return style.includes('/') ? style.split('/') : [style, style];
  }

  function isSpecializedHeadsetOptionEligible() {
    const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';
    const [topSpec] = getSelectedHeadsetStyleSpecs();
    return (position === 'top' || position === 'both') && topSpec === 'IS' && String(getSelectedUpperSize()) === '42';
  }

  function setSpecializedFrameSelection(label) {
    const section = document.querySelector('[data-group="specialized frame"]');
    const subtitle = section?.querySelector('.section-subtitle');
    const buttons = section ? Array.from(section.querySelectorAll('.option-button')) : [];
    buttons.forEach(button => {
      button.classList.toggle('selected', button.textContent.trim() === label);
    });
    if (subtitle) subtitle.textContent = label;
  }

  function updateSpecializedFrameSection() {
    const eligible = isSpecializedHeadsetOptionEligible();
    toggleSection('specialized frame', eligible);
    if (!eligible) setSpecializedFrameSelection('No');
  }

  function setupSpecializedFrameInteraction() {
    const group = document.querySelector('[data-group="specialized frame"] .button-group');
    const subtitle = document.querySelector('[data-group="specialized frame"] .section-subtitle');
    if (!group) return;

    group.addEventListener('click', e => {
      const btn = e.target.closest('.option-button');
      if (!btn) return;
      group.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      if (subtitle) subtitle.textContent = btn.textContent.trim();
      drawHeadsetToCanvas();
      updateSelectedVariantId();
    });
  }

  setupSpecializedFrameInteraction();

  function updateColorMenus(colorMode, position) {
    const show = (groupName, shouldShow) => {
      const section = document.querySelector(`[data-group="${groupName}"]`);
      if (section) section.style.display = shouldShow ? 'block' : 'none';
    };

    const isSolid = colorMode === 'Solid';
    const showTop = position === 'top' || position === 'both';
    const showBottom = position === 'bottom' || position === 'both';
    const style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim() || '';
    const [topSpec, bottomSpec] = style.includes('/') ? style.split('/') : [style, style];
    const topHasCup = headsetSpecHasCup(topSpec);
    const bottomHasCup = headsetSpecHasCup(bottomSpec);

    show('solid color', isSolid);
    show('top cap color', !isSolid && showTop);
    show('top cover color', !isSolid && showTop);
    show('top cup color', !isSolid && showTop && topHasCup);
    show('bottom cup color', !isSolid && showBottom && bottomHasCup);

    drawHeadsetToCanvas();
  }

  function updateStyleButtonsForPosition(position) {
    const group = document.querySelector('[data-group="style"] .button-group');
    const subtitle = document.querySelector('[data-group="style"] .section-subtitle');
    if (!group) return;
    const styles = styleOptionsByPosition[position] || [];
    group.innerHTML = '';
    styles.forEach((style, index) => {
      const btn = document.createElement('button');
      btn.className = 'option-button' + (index === 0 ? ' selected' : '');
      btn.textContent = style;
      group.appendChild(btn);
      btn.addEventListener('click', () => {
        group.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        if (subtitle) subtitle.textContent = style;
        updateMenusForSpec(style, position);
        const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim() || 'Solid';
        updateColorMenus(colorMode, position);
        updateSpecializedFrameSection();
        drawHeadsetToCanvas();
        updateSelectedVariantId();
      });
      if (index === 0 && subtitle) subtitle.textContent = style;
    });
  }

  function updateMenusForSpec(spec, overridePosition = null) {
    const positionSelected = overridePosition || document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';
    let topSpecData = null;
    let bottomSpecData = null;

    if (spec === 'EC/EC') {
      topSpecData = i9_menu.specs['EC'];
      bottomSpecData = i9_menu.specs['EC'];
    } else if (spec === 'ZS/EC') {
      topSpecData = i9_menu.specs['ZS'];
      bottomSpecData = i9_menu.specs['EC'];
    } else if (spec === 'ZS/ZS') {
      topSpecData = i9_menu.specs['ZS'];
      bottomSpecData = i9_menu.specs['ZS'];
    } else if (spec === 'IS/IS') {
      topSpecData = i9_menu.specs['IS'];
      bottomSpecData = i9_menu.specs['IS'];
    } else {
      topSpecData = i9_menu.specs[spec];
      bottomSpecData = i9_menu.specs[spec];
    }

    const topHeights = topSpecData.heights || {};
    toggleSection('top cover height', Object.keys(topHeights).length > 0 && (positionSelected === 'top' || positionSelected === 'both'));
    if (Object.keys(topHeights).length > 0) {
      updateButtonGroup('top cover height', Object.keys(topHeights).map(h => h + 'mm'));
    }

    const upper = topSpecData.bore_size?.upper || [];
    toggleSection('upper headtube bore', upper.length > 0 && (positionSelected === 'top' || positionSelected === 'both'));
    if (upper.length > 0) {
      updateButtonGroup('upper headtube bore', upper.map(b => b.size + 'mm'));
    }

    const lower = bottomSpecData.bore_size?.lower || [];
    toggleSection('lower headtube bore', lower.length > 0 && (positionSelected === 'bottom' || positionSelected === 'both'));
    if (lower.length > 0) {
      updateButtonGroup('lower headtube bore', lower.map(b => b.size + 'mm'));
    }

    updateSpecializedFrameSection();
  }

  function toggleSection(groupName, shouldShow) {
    const section = document.querySelector(`[data-group="${groupName}"]`);
    if (section) section.style.display = shouldShow ? 'block' : 'none';
  }

  function updateButtonGroup(groupName, values) {
    const group = document.querySelector(`[data-group="${groupName}"] .button-group`);
    const subtitle = document.querySelector(`[data-group="${groupName}"] .section-subtitle`);
    if (!group) return;
    group.innerHTML = '';
    values.forEach((val, i) => {
      const btn = document.createElement('button');
      btn.className = 'option-button' + (i === 0 ? ' selected' : '');
      btn.textContent = val;
      group.appendChild(btn);
      btn.addEventListener('click', () => {
        group.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        if (subtitle) subtitle.textContent = val;
        drawHeadsetToCanvas();
        updateSelectedVariantId();
      });
      if (i === 0 && subtitle) subtitle.textContent = val;
    });
  }

  function updateSelectedVariantId() {
    const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim();
    let style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
    let colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim();

    if (!position || !style || !colorMode) {
      selectedVariantId = null;
      return;
    }

    if (style === 'ZS') style = 'ZS/ZS';
    if (style === 'IS') style = 'IS/IS';
    if (style === 'EC') style = 'EC/EC';

    if (position === 'Bottom') {
      colorMode = 'Solid';
      const allColorBtns = document.querySelectorAll('[data-group="color"] .button-group .option-button');
      allColorBtns.forEach(btn => btn.classList.remove('selected'));
      const solidBtn = Array.from(allColorBtns).find(btn => btn.textContent.trim() === 'Solid');
      if (solidBtn) solidBtn.classList.add('selected');
    }

    const match = Array.isArray(productVariants)
      ? productVariants.find(v =>
          v.option1?.trim() === position &&
          v.option2?.trim() === style &&
          v.option3?.trim() === colorMode
        )
      : null;

    if (match) {
      selectedVariantId = match.id;
    } else {
      selectedVariantId = null;
    }

    scheduleHeadsetQuoteRefresh();
  }

  function buildHeadsetQuotePayload() {
    if (typeof buildSenderFromMenu !== 'function') return null;
    const ass = buildSenderFromMenu();
    if (!ass || !ass.position) return null;
    const ctx = i9_get_headset_shopper_context();
    const payload = {
      type: 'quote_headset',
      ass,
      response_scope: ctx.response_scope,
      price_tier: ctx.price_tier,
      currency_code: ctx.currency_code,
      country_code: ctx.country_code,
      country_name: ctx.country_name,
      display_vat_inclusive: ctx.display_vat_inclusive
    };
    if (ctx.currency_rate !== null) payload.currency_rate = ctx.currency_rate;
    if (window.I9_STORE) payload.store = window.I9_STORE;
    return payload;
  }

  function headsetQuoteCacheKey(payload) {
    if (!payload) return '';
    const copy = { ...payload };
    delete copy.type;
    delete copy.store;
    return JSON.stringify(copy);
  }

  function getCachedHeadsetQuote(key) {
    if (!key || !i9HeadsetQuoteCache.has(key)) return null;
    const hit = i9HeadsetQuoteCache.get(key);
    if (!hit || typeof hit !== 'object') return null;
    if ((Date.now() - Number(hit.ts || 0)) > I9_HEADSET_QUOTE_CACHE_TTL_MS) {
      i9HeadsetQuoteCache.delete(key);
      return null;
    }
    return hit.data || null;
  }

  function setCachedHeadsetQuote(key, data) {
    if (!key || !data || typeof data !== 'object') return;
    i9HeadsetQuoteCache.set(key, { ts: Date.now(), data });
    while (i9HeadsetQuoteCache.size > I9_HEADSET_QUOTE_CACHE_MAX) {
      const first = i9HeadsetQuoteCache.keys().next().value;
      if (!first) break;
      i9HeadsetQuoteCache.delete(first);
    }
  }

  function getVariantFallbackPrice() {
    const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim();
    let style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
    let colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim();
    if (!position || !style || !colorMode) return null;

    if (style === 'ZS') style = 'ZS/ZS';
    if (style === 'IS') style = 'IS/IS';
    if (style === 'EC') style = 'EC/EC';
    if (position === 'Bottom') colorMode = 'Solid';

    const hit = Array.isArray(productVariants)
      ? productVariants.find(v =>
          v.option1?.trim() === position &&
          v.option2?.trim() === style &&
          v.option3?.trim() === colorMode
        )
      : null;
    if (!hit) return null;
    const n = Number(hit.price) / 100;
    return Number.isFinite(n) ? n : null;
  }

  function getHeadsetPricingContextKey() {
    const ctx = i9_get_headset_shopper_context();
    return JSON.stringify({
      price_tier: ctx.price_tier,
      currency_code: ctx.currency_code,
      country_code: ctx.country_code,
      display_vat_inclusive: ctx.display_vat_inclusive,
      currency_rate: ctx.currency_rate
    });
  }

  function normalizeHeadsetColorName(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (raw.toUpperCase() === 'NA') return 'NA';
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
  }

  function getHeadsetPriceEntryValue(entry) {
    if (entry === null || entry === undefined) return null;
    if (Array.isArray(entry)) {
      const first = Number(entry[0]);
      return Number.isFinite(first) ? first : null;
    }
    const direct = Number(entry);
    return Number.isFinite(direct) ? direct : null;
  }

  function isHeadsetMixedConfig(ass) {
    if (!ass || typeof ass !== 'object') return false;
    if (ass.position === 'both') {
      const colors = [
        normalizeHeadsetColorName(ass.top_cap_color),
        normalizeHeadsetColorName(ass.top_cover_color),
        normalizeHeadsetColorName(ass.top_cup_color),
        normalizeHeadsetColorName(ass.bottom_cup_color)
      ].filter((color) => color && color !== 'NA');
      return new Set(colors).size > 1;
    }
    if (ass.position === 'top') {
      const colors = [
        normalizeHeadsetColorName(ass.top_cap_color),
        normalizeHeadsetColorName(ass.top_cover_color),
        normalizeHeadsetColorName(ass.top_cup_color)
      ].filter((color) => color && color !== 'NA');
      return new Set(colors).size > 1;
    }
    return false;
  }

  function getLocalHeadsetBasePriceFromAss(ass) {
    if (!ass || typeof ass !== 'object') return null;
    const topSpecData = ass.top_spec ? i9_menu?.specs?.[ass.top_spec] : null;
    const bottomSpecData = ass.bottom_spec ? i9_menu?.specs?.[ass.bottom_spec] : null;
    const charges = topSpecData?.charges || bottomSpecData?.charges || {};
    const bothDiscount = Number(charges.both_discount || 0);
    const colorMixBoth = Number(charges.color_mix_both || 0);
    const colorMixTop = Number(charges.color_mix_top || 0);
    const mixed = isHeadsetMixedConfig(ass);

    if (ass.position === 'both') {
      const topPrice = getHeadsetPriceEntryValue(
        topSpecData?.prices?.top?.[String(ass.upper_headtube_bore)]?.[String(ass.height)]
      );
      const bottomPrice = getHeadsetPriceEntryValue(
        bottomSpecData?.prices?.bottom?.[String(ass.lower_headtube_bore)]
      );
      if (!Number.isFinite(topPrice) || !Number.isFinite(bottomPrice)) return null;
      return topPrice + bottomPrice - bothDiscount + (mixed ? colorMixBoth : 0);
    }

    if (ass.position === 'top') {
      const topPrice = getHeadsetPriceEntryValue(
        topSpecData?.prices?.top?.[String(ass.upper_headtube_bore)]?.[String(ass.height)]
      );
      if (!Number.isFinite(topPrice)) return null;
      return topPrice + (mixed ? colorMixTop : 0);
    }

    if (ass.position === 'bottom') {
      const bottomPrice = getHeadsetPriceEntryValue(
        bottomSpecData?.prices?.bottom?.[String(ass.lower_headtube_bore)]
      );
      return Number.isFinite(bottomPrice) ? bottomPrice : null;
    }

    return null;
  }

  function cacheHeadsetDisplayFactor(payload, data) {
    const displayPrice = Number(data?.display_price);
    const localBase = getLocalHeadsetBasePriceFromAss(payload?.ass);
    if (!Number.isFinite(displayPrice) || !Number.isFinite(localBase) || localBase <= 0) return;
    i9HeadsetDisplayFactorCache.set(getHeadsetPricingContextKey(), displayPrice / localBase);
  }

  function getImmediateHeadsetEstimatedPrice(payload) {
    if (i9_requires_final_headset_price()) return null;

    const localBase = getLocalHeadsetBasePriceFromAss(payload?.ass);
    if (!Number.isFinite(localBase)) return null;

    const factor = Number(i9HeadsetDisplayFactorCache.get(getHeadsetPricingContextKey()));
    if (Number.isFinite(factor) && factor > 0) {
      return Math.round(localBase * factor * 100) / 100;
    }

    if (canUseVariantFallbackPrice()) {
      const fallbackVariant = getVariantFallbackPrice();
      if (Number.isFinite(fallbackVariant)) return fallbackVariant;
    }

    return null;
  }

  function renderImmediateHeadsetEstimate(payload) {
    const estimated = getImmediateHeadsetEstimatedPrice(payload);
    if (!Number.isFinite(estimated)) return false;
    i9_render_headset_price_value(estimated);
    return true;
  }

  function canUseVariantFallbackPrice() {
    const shopperContext = i9_get_headset_shopper_context();
    return shopperContext.price_tier === 'retail' && shopperContext.currency_code === 'USD';
  }

  function tryRenderVariantFallbackPrice() {
    if (i9_requires_final_headset_price()) return false;
    if (!canUseVariantFallbackPrice()) return false;
    const fallbackVariant = getVariantFallbackPrice();
    if (!Number.isFinite(fallbackVariant)) return false;
    i9_render_headset_price_value(fallbackVariant);
    return true;
  }

function renderHeadsetQuotePrice(data) {
  i9_apply_headset_vat_context(data);
  const direct = Number(data?.display_price);
  if (Number.isFinite(direct)) {
    i9_render_headset_price_value(direct);
    i9_release_headset_price_gate();
    return true;
  }
  const bag = data?.prices;
  const fallbackBag = (bag && typeof bag === 'object') ? Number(bag.display) : null;
  if (Number.isFinite(fallbackBag)) {
    i9_render_headset_price_value(fallbackBag);
    i9_release_headset_price_gate();
    return true;
  }
  return tryRenderVariantFallbackPrice();
}

  async function refreshHeadsetQuote() {
    const payload = buildHeadsetQuotePayload();
    if (!payload) return;

    const key = headsetQuoteCacheKey(payload);
    const cached = getCachedHeadsetQuote(key);
    if (cached) {
      if (!renderHeadsetQuotePrice(cached)) i9_set_headset_price_pending(false);
      return;
    }

    i9_set_headset_price_pending(true);

    if (i9HeadsetQuoteAbort) {
      try { i9HeadsetQuoteAbort.abort(); } catch (_) {}
    }

    const ctrl = new AbortController();
    i9HeadsetQuoteAbort = ctrl;
    const seq = ++i9HeadsetQuoteSeq;
    const base = (window.I9_API_BUILD_URL || window.I9_API_BASE || 'https://api.i9.bike').replace(/\/$/, '');

    try {
      const res = await fetch(`${base}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: ctrl.signal
      });
      const data = await res.json().catch(() => null);
      if (!data || data.ok !== true) {
        if (!tryRenderVariantFallbackPrice()) {
          if (i9_requires_final_headset_price()) {
            i9_release_headset_price_gate();
          } else {
            i9_set_headset_price_pending(false);
          }
        }
        return;
      }
      if (seq !== i9HeadsetQuoteSeq) return;
      setCachedHeadsetQuote(key, data);
      cacheHeadsetDisplayFactor(payload, data);
      if (!renderHeadsetQuotePrice(data)) i9_set_headset_price_pending(false);
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      if (!tryRenderVariantFallbackPrice()) {
        if (i9_requires_final_headset_price()) {
          i9_release_headset_price_gate();
        } else {
          i9_set_headset_price_pending(false);
        }
      }
      console.warn('Headset quote pricing failed', err);
    }
  }

  function scheduleHeadsetQuoteRefresh() {
    clearTimeout(i9QuoteDebounceTimer);
    const payload = buildHeadsetQuotePayload();
    const key = payload ? headsetQuoteCacheKey(payload) : '';
    if (key && !getCachedHeadsetQuote(key) && !renderImmediateHeadsetEstimate(payload)) {
      i9_set_headset_price_pending(true);
    }
    i9QuoteDebounceTimer = setTimeout(() => {
      refreshHeadsetQuote();
    }, 120);
  }

  document.querySelectorAll('[data-group="color"] .option-button').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.button-group').querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      const label = btn.textContent.trim();
      document.querySelector('[data-group="color"] .section-subtitle').textContent = label;
      const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';
      updateColorMenus(label, position);
      updateSelectedVariantId();
    });
  });

  document.querySelectorAll('[data-group="position"] .option-button').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.button-group').querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      const label = btn.textContent.trim();
      document.querySelector('[data-group="position"] .section-subtitle').textContent = label;
      updateStyleButtonsForPosition(label.toLowerCase());
      const selectedStyle = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
      updateMenusForSpec(selectedStyle, label.toLowerCase());
      const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim();
      updateColorMenus(colorMode, label.toLowerCase());
      updateSpecializedFrameSection();
      updateSelectedVariantId();
    });
  });

  function syncSelectSubtitle(selectEl) {
    const section = selectEl.closest('.section');
    const subtitle = section?.querySelector('.section-subtitle');
    const opt = selectEl.options[selectEl.selectedIndex];
    if (subtitle && opt) subtitle.textContent = opt.textContent.trim();
  }

  document.querySelectorAll('.styled-dropdown').forEach(select => {
    select.addEventListener('change', () => {
      syncSelectSubtitle(select);
      drawHeadsetToCanvas();
      updateSelectedVariantId();
    });
    syncSelectSubtitle(select);
  });

  updateStyleButtonsForPosition('both');
  const defaultStyle = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
  if (defaultStyle) updateMenusForSpec(defaultStyle, 'both');
  const defaultColor = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim() || 'Solid';
  updateColorMenus(defaultColor, 'both');
  updateSpecializedFrameSection();
  drawHeadsetToCanvas();
  updateSelectedVariantId();
  bootstrapHeadsetVatInfo();
});

// -------------------------
// Canvas Setup + Drawing
// -------------------------

window.addEventListener('load', () => {
  const mediaGallery = document.querySelector('media-gallery, .product__media-wrapper');
  if (mediaGallery && !document.getElementById('headset-canvas')) {
    const canvas = document.createElement('canvas');
    canvas.id = 'headset-canvas';
    canvas.width = 600;
    canvas.height = 600;
    canvas.style.width = '100%';
    canvas.style.height = 'auto';
    canvas.style.display = 'block';
    mediaGallery.innerHTML = '';
    mediaGallery.appendChild(canvas);
    requestAnimationFrame(drawHeadsetToCanvas);
  }
});

function drawHeadsetToCanvas() {
  const canvas = document.getElementById('headset-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  const style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
  const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim() || 'Solid';
  const isSolid = colorMode === 'Solid';
  const solidColor = document.getElementById('solid-color')?.selectedOptions[0]?.textContent.toLowerCase();
  const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';

  const showTop = position === 'top' || position === 'both';
  const showBottom = position === 'bottom' || position === 'both';

  const height = getSelectedHeight();
  const upperSize = getSelectedUpperSize();
  const lowerSize = getSelectedLowerSize();

  const topSpec = style.includes('/') ? style.split('/')[0] : style;
  const bottomSpec = style.includes('/') ? style.split('/')[1] : style;

  const topSpecData = i9_menu.specs[topSpec];
  const bottomSpecData = i9_menu.specs[bottomSpec];

  const imageSources = [];

  if (showTop && topSpecData?.pictures?.hs_top_cap_color) {
    const color = isSolid ? solidColor : document.getElementById('top-cap-color')?.selectedOptions[0]?.textContent.toLowerCase();
    if (color) imageSources.push(`https://api.i9.bike/images/hsv4/${topSpecData.pictures.hs_top_cap_color}/${color}.png`);
  }

  if (showTop && topSpecData?.pictures?.hs_top_cover_color?.[height]) {
    const color = isSolid ? solidColor : document.getElementById('top-cover-color')?.selectedOptions[0]?.textContent.toLowerCase();
    if (color) imageSources.push(`https://api.i9.bike/images/hsv4/${topSpecData.pictures.hs_top_cover_color[height]}/${color}.png`);
  }

  if (showTop) imageSources.push("https://api.i9.bike/images/hsv4/bearings/top.png");

  if (showTop && topSpecData?.pictures?.hs_top_cup_color?.[upperSize]) {
    const color = isSolid ? solidColor : document.getElementById('top-cup-color')?.selectedOptions[0]?.textContent.toLowerCase();
    if (color) imageSources.push(`https://api.i9.bike/images/hsv4/${topSpecData.pictures.hs_top_cup_color[upperSize]}/${color}.png`);
  }

  if (showBottom && bottomSpecData?.pictures?.hs_bottom_cup_color?.[lowerSize]) {
    const color = isSolid ? solidColor : document.getElementById('bottom-cup-color')?.selectedOptions[0]?.textContent.toLowerCase();
    if (color) imageSources.push(`https://api.i9.bike/images/hsv4/${bottomSpecData.pictures.hs_bottom_cup_color[lowerSize]}/${color}.png`);
  }

  if (showBottom) imageSources.push("https://api.i9.bike/images/hsv4/bearings/bottom.png");

  loadAndDrawStackedImages(ctx, canvas, imageSources);
}

function getSelectedHeight() {
  return document.querySelector('[data-group="top cover height"] .option-button.selected')?.textContent.replace('mm', '').trim() || '5';
}
function getSelectedUpperSize() {
  return document.querySelector('[data-group="upper headtube bore"] .option-button.selected')?.textContent.replace('mm', '').trim() || '44';
}
function getSelectedLowerSize() {
  return document.querySelector('[data-group="lower headtube bore"] .option-button.selected')?.textContent.replace('mm', '').trim() || '56';
}

function loadAndDrawStackedImages(ctx, canvas, urls) {
  const images = [];
  let loaded = 0;
  if (urls.length === 0) return;

  urls.forEach((url, index) => {
    const img = new Image();
    img.onload = () => {
      images[index] = img;
      loaded++;
      if (loaded === urls.length) {
        const padding = 10;
        const totalHeight = images.reduce((sum, img) => {
          const scale = canvas.width / img.width;
          return sum + (img.height * scale) + padding;
        }, -padding);

        if (totalHeight > canvas.height) {
          canvas.height = Math.ceil(totalHeight + 20);
        }

        renderStackedImages(ctx, canvas, images);
      }
    };
    img.onerror = () => {
      loaded++;
      if (loaded === urls.length) {
        renderStackedImages(ctx, canvas, images);
      }
    };
    img.src = url;
  });
}

function renderStackedImages(ctx, canvas, images) {
  const padding = 10;
  const totalHeight = images.reduce((sum, img) => sum + (canvas.width / img.width * img.height), 0) + (images.length - 1) * padding;
  let y = (canvas.height - totalHeight) / 2;
  images.forEach(img => {
    const scale = canvas.width / img.width;
    const width = canvas.width;
    const height = img.height * scale;
    ctx.drawImage(img, 0, y, width, height);
    y += height + padding;
  });
}

// ---------- Loading helpers ----------
function i9ShowLoading(title = 'Working…', desc = 'Please wait.') {
  const el = document.getElementById('i9Loading');
  if (!el) return;
  el.setAttribute('aria-hidden', 'false');
  const t = document.getElementById('i9LoadingTitle');
  const d = document.getElementById('i9LoadingDesc');
  const live = document.getElementById('i9LoadingLive');
  if (t) t.textContent = title;
  if (d) d.textContent = desc;
  if (live) live.textContent = title + ' ' + desc;
  document.body.style.overflow = 'hidden'; // lock scroll
}

function i9UpdateLoading(title, desc) {
  const t = document.getElementById('i9LoadingTitle');
  const d = document.getElementById('i9LoadingDesc');
  const live = document.getElementById('i9LoadingLive');
  if (t && title) t.textContent = title;
  if (d && desc)  d.textContent = desc;
  if (live) live.textContent = (title || t?.textContent || '') + ' ' + (desc || d?.textContent || '');
}

function i9HideLoading() {
  const el = document.getElementById('i9Loading');
  if (!el) return;
  el.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = ''; // unlock scroll
}

function i9GetCartSections() {
  let sections = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
  );
  const cartDrawer = document.querySelector('cart-drawer');
  const mainCart = document.querySelector('cart-items');
  if (cartDrawer?.getSectionsToRender) {
    sections = sections.concat(cartDrawer.getSectionsToRender().map((s) => s.id));
  }
  if (mainCart?.getSectionsToRender) {
    sections = sections.concat(mainCart.getSectionsToRender().map((s) => s.section));
  }
  return sections;
}

function i9GetQuantity(root) {
  const rootForm = root?.closest?.('form');
  if (rootForm?.id) {
    const byForm = document.querySelector(`input[name="quantity"][form="${rootForm.id}"]`);
    const vForm = parseInt(byForm?.value, 10);
    if (Number.isFinite(vForm) && vForm > 0) return vForm;
  }
  const selectors = [
    'form[action*="/cart/add"] input[name="quantity"]',
    'quantity-input input[name="quantity"]',
    '.quantity__input',
    'input[name="quantity"]',
    '.i9wc-quantity input'
  ];
  const findAll = (ctx) => {
    if (!ctx || !ctx.querySelectorAll) return [];
    const list = [];
    selectors.forEach((sel) => ctx.querySelectorAll(sel).forEach((el) => list.push(el)));
    return list;
  };
  const pickVisible = (list) => list.find((el) => el && el.offsetParent !== null && !el.disabled) || list[0];

  const scope =
    root && (root.closest?.('form') || root.closest?.('[data-product-id]') || root.closest?.('.product') || root);
  let candidates = findAll(scope);
  if (!candidates.length) candidates = findAll(document);
  const input = pickVisible(candidates);
  const v = parseInt(input?.value, 10);
  return Number.isFinite(v) && v > 0 ? v : 1;
}

async function i9AddVariantToCart(variantId, qty = 1, properties = null) {
  const addUrl = window.FoxThemeSettings?.routes?.cart_add_url || '/cart/add.js';
  const sections = i9GetCartSections();
  const buildFormData = () => {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', qty);
    if (properties && typeof properties === 'object') {
      Object.entries(properties).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        formData.append(`properties[${key}]`, value);
      });
    }
    if (sections.length) {
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }
    return formData;
  };

  let data = {};
  for (let attempt = 1; attempt <= 5; attempt++) {
    const res = await fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: buildFormData()
    });

    data = await res.json().catch(() => ({}));
    if (!(data && data.status)) break;

    const msg = String(data.description || data.message || 'Add to cart failed');
    const retryable = Number(data.status) === 422 && /(sold out|unavailable|cannot be purchased)/i.test(msg);
    if (retryable && attempt < 5) {
      await new Promise((resolve) => setTimeout(resolve, attempt * 500));
      continue;
    }

    const e = new Error(`add.js failed (${data.status}). ${msg}`);
    e.status = data.status;
    e.variantId = variantId;
    throw e;
  }

  if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== 'undefined') {
    window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, data);
  }
  return data;
}

// ---------- Add to Cart (with progress UI) ----------
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('button[type="submit"][name="add"]');
  if (!btn) return;

  // block double clicks while busy
  if (btn.dataset.loading === '1') {
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  try {
    btn.dataset.loading = '1';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    i9ShowLoading('Building your headset…', 'This can take a few seconds.');
    var sender = buildSenderFromMenu();
    const shopperContext = i9_get_headset_shopper_context();

    // Step 1: make_headset
    const base = (window.I9_API_BUILD_URL || window.I9_API_BASE || 'https://api.i9.bike').replace(/\/$/, '');
    const payload = {
      ass: sender,
      type: "make_headset",
      response_scope: shopperContext.response_scope,
      price_tier: shopperContext.price_tier,
      currency_code: shopperContext.currency_code,
      country_code: shopperContext.country_code,
      country_name: shopperContext.country_name,
      page_path: window.location.pathname || '/products/headset',
      display_vat_inclusive: shopperContext.display_vat_inclusive
    };
    if (shopperContext.currency_rate !== null) payload.currency_rate = shopperContext.currency_rate;
    if (window.I9_STORE) payload.store = window.I9_STORE;
    const makeRes = await fetch(`${base}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    let data;
    try {
      data = await makeRes.json();
    } catch {
      throw new Error('Invalid response from builder.');
    }

    if (!data || data.ok !== true || !data.variantId) {
      throw new Error(data?.message || 'Builder did not return a valid variantId.');
    }

    // Step 2: add to cart
    i9UpdateLoading('Adding to cart…', 'Almost done.');
    const variantGid = data.variantId || "";
    const variantIdNum = variantGid.split("/").pop();

    const imageUrl =
      data?.picture ||
      data?.i9_attributes?.image ||
      data?.attributes?.image ||
      data?.image ||
      null;
    const qty = i9GetQuantity(btn);
    const cartData = await i9AddVariantToCart(
      variantIdNum,
      qty,
      imageUrl ? { _i9_image: imageUrl } : null
    );

    i9UpdateLoading('Success!', 'Your headset was added to the cart.');
    setTimeout(() => { i9HideLoading(); }, 500);
    const hasDrawerSection = !!(cartData?.sections && cartData.sections['cart-drawer']);
    if (!hasDrawerSection) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    } else if (window.FoxTheme?.CartDrawer?.openDrawer) {
      window.FoxTheme.CartDrawer.openDrawer();
    }
    if (window.FoxThemeCartHelpers?.getState) {
      FoxThemeCartHelpers.getState().then((state) => {
        FoxThemeCartHelpers.updateCartCount(state.item_count);
      });
    }

    // Optionally refresh your cart badge / header here
    // updateCartBadgeCount?.();
    // refreshHeaderCartIcon?.();

  } catch (err) {
    console.error("Add to cart failed", err);
    i9UpdateLoading('Something went wrong', (err && err.message) ? err.message : 'Please try again.');
    setTimeout(() => { i9HideLoading(); }, 1200);
    alert("Failed to add to cart. " + (err?.message || 'Please try again.'));
  } finally {
    btn.dataset.loading = '0';
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
  }
}, true);

function headsetSpecHasCup(spec) {
  return String(spec || '').trim().toUpperCase() !== 'IS';
}

function getHeadsetCupColor(spec, selectedColor) {
  return headsetSpecHasCup(spec) ? selectedColor : 'NA';
}

function getSpecializedHeadsetPayloadValue(position, topSpec, upperHeadtubeBore) {
  const selectedLabel = document.querySelector('[data-group="specialized frame"] .option-button.selected')?.textContent.trim();
  const isEligible = (position === 'top' || position === 'both') && topSpec === 'IS' && Number(upperHeadtubeBore) === 42;
  return isEligible && selectedLabel === 'Yes' ? 'S' : 'X';
}

function buildSenderFromMenu() {
  const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase();
  const style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
  const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim();
  const solidColor = document.getElementById('solid-color')?.selectedOptions[0]?.textContent.toLowerCase();

  // Split style into top_spec / bottom_spec
  let top_spec, bottom_spec;
  if (style.includes('/')) {
    [top_spec, bottom_spec] = style.split('/');
  } else {
    top_spec = bottom_spec = style;
  }

  const sender = {
    position: position,
    bearings: "S"
  };

  // ----- TOP PROPERTIES -----
  if (position === 'top' || position === 'both') {
    sender.top_spec = top_spec;
    sender.upper_headtube_bore = parseInt(getSelectedUpperSize());
    sender.height = parseInt(getSelectedHeight());
    sender.specialized = getSpecializedHeadsetPayloadValue(position, top_spec, sender.upper_headtube_bore);

    if (colorMode === 'Solid') {
      sender.top_cover_color = solidColor;
      sender.top_cap_color = solidColor;
      sender.top_cup_color = getHeadsetCupColor(top_spec, solidColor);
    } else {
      sender.top_cover_color = document.getElementById('top-cover-color')?.selectedOptions[0]?.textContent.toLowerCase();
      sender.top_cap_color = document.getElementById('top-cap-color')?.selectedOptions[0]?.textContent.toLowerCase();
      const topCupColor = document.getElementById('top-cup-color')?.selectedOptions[0]?.textContent.toLowerCase();
      sender.top_cup_color = getHeadsetCupColor(top_spec, topCupColor);
    }
  }

  // ----- BOTTOM PROPERTIES -----
  if (position === 'bottom' || position === 'both') {
    sender.bottom_spec = bottom_spec;
    sender.lower_headtube_bore = parseInt(getSelectedLowerSize());

    if (colorMode === 'Solid') {
      sender.bottom_cup_color = getHeadsetCupColor(bottom_spec, solidColor);
    } else {
      const bottomCupColor = document.getElementById('bottom-cup-color')?.selectedOptions[0]?.textContent.toLowerCase();
      sender.bottom_cup_color = getHeadsetCupColor(bottom_spec, bottomCupColor);
    }
  }

  if (!sender.specialized) sender.specialized = 'X';

  // use global encoded cfg (set by URL state script)
  sender.menu_load = window.currentCfgEncoded || (window.i9State?.encode ? encodeURIComponent(window.i9State.encode()) : '');
  return sender;
}

/* ===============================
   I9 Headset Config: URL State Save/Restore (compact scheme)
   =============================== */
(function () {
  // ---- URL-safe current cfg for easy sharing ----
  let currentCfgEncoded = "";
  let saveTimer = null;
  let isRestoring = false;

  // Expose it for your code if you want to read it
  window.currentCfgEncoded = currentCfgEncoded;

  // ---- compact codes (URL-friendly) ----
  const PositionCode = { both: 'b', top: 't', bottom: 'd' };
  const StyleCode = {
    'ZS/ZS': 'zz', 'IS/IS': 'ii', 'EC/EC': 'ee', 'ZS/EC': 'ze',
    'ZS': 'z', 'IS': 'i', 'EC': 'e'
  };
  const StyleFromCode = {
    zz: 'ZS/ZS', ii: 'IS/IS', ee: 'EC/EC', ze: 'ZS/EC',
    z: 'ZS', i: 'IS', e: 'EC'
  };
  const ColorModeCode = { Solid: 's', Custom: 'c' };
  const ColorModeFromCode = { s: 'Solid', c: 'Custom' };

  // ---- DOM helpers ----
  function findOptionButton(groupName, labelText) {
    const group = document.querySelector(`[data-group="${groupName}"] .button-group`);
    if (!group) return null;
    return Array.from(group.querySelectorAll('.option-button'))
      .find(b => b.textContent.trim() === String(labelText).trim());
  }

  // Prefer real clicks to trigger your existing listeners (price logic etc.)
  function clickOption(groupName, labelText) {
    const btn = findOptionButton(groupName, labelText);
    if (!btn) return false;
    btn.click(); // fire your handlers
    return true;
  }

  function setSelectByColorId(selectId, colorId, fireChange = true) {
    const sel = document.getElementById(selectId);
    if (!sel) return;
    const opt = Array.from(sel.options).find(
      o => (o.getAttribute('data-color') || '') == String(colorId)
    );
    if (opt) {
      sel.value = opt.value;
      if (fireChange) sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getSelectedText(selector) {
    return document.querySelector(selector)?.textContent.trim();
  }

  function getSelectedColorId(selectId) {
    const sel = document.getElementById(selectId);
    return sel?.selectedOptions?.[0]?.getAttribute('data-color') || '';
  }

  // ---- ENCODE current UI to compact "k=v;..." string ----
  function encodeMenuState() {
    const positionLabel = getSelectedText('[data-group="position"] .option-button.selected') || 'Both';
    const position = positionLabel.toLowerCase();
    let style = getSelectedText('[data-group="style"] .option-button.selected') || 'ZS/ZS';
    const colorMode = getSelectedText('[data-group="color"] .option-button.selected') || 'Solid';

    // normalize single styles for top/bottom
    if (position === 'top' || position === 'bottom') {
      if (style === 'ZS/ZS') style = 'ZS';
      if (style === 'IS/IS') style = 'IS';
      if (style === 'EC/EC') style = 'EC';
    }

    const p = PositionCode[position] || 'b';
    const s = StyleCode[style] || 'zz';

    // these helpers exist in your configurator JS
    const h = (typeof getSelectedHeight === 'function' ? getSelectedHeight() : '5');
    const u = (typeof getSelectedUpperSize === 'function' ? getSelectedUpperSize() : '44');
    const l = (typeof getSelectedLowerSize === 'function' ? getSelectedLowerSize() : '56');

    const c = ColorModeCode[colorMode] || 's';
    const topSpec = style.includes('/') ? style.split('/')[0] : style;
    const sp = getSpecializedHeadsetPayloadValue(position, topSpec, u) === 'S' ? 'y' : '';

    // color IDs
    const sc  = getSelectedColorId('solid-color') || '';
    const tcc = getSelectedColorId('top-cap-color') || '';
    const tvc = getSelectedColorId('top-cover-color') || '';
    const tuc = getSelectedColorId('top-cup-color') || '';
    const bc  = getSelectedColorId('bottom-cup-color') || '';

    const pairs = [
      `p=${p}`, `s=${s}`, `h=${h}`, `u=${u}`, `l=${l}`, `c=${c}`,
      sp ? `sp=${sp}` : '',
      sc ? `sc=${sc}` : '',
      tcc ? `tcc=${tcc}` : '',
      tvc ? `tvc=${tvc}` : '',
      tuc ? `tuc=${tuc}` : '',
      bc ? `bc=${bc}` : ''
    ].filter(Boolean);

    return pairs.join(';');
  }

  // ---- DECODE "k=v;..." -> object (also tolerates old/new JSON by auto-detect) ----
  function decodeMenuState(cfg) {
    if (!cfg) return {};
    const trimmed = cfg.trim();
    if ((trimmed.startsWith('{') && trimmed.endsWith('}')) ||
        (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
      try {
        const j = JSON.parse(trimmed);
        const outFromJson = {};
        if (j.pos) outFromJson.p = ({Both:'b',Top:'t',Bottom:'d'}[j.pos] || 'b');
        if (j.style) {
          const map = {'ZS/ZS':'zz','IS/IS':'ii','EC/EC':'ee','ZS/EC':'ze','ZS':'z','IS':'i','EC':'e'};
          outFromJson.s = map[j.style] || 'zz';
        }
        if (j.tch) outFromJson.h = (j.tch.replace('mm','').trim());
        if (j.uht) outFromJson.u = (j.uht.replace('mm','').trim());
        if (j.lht) outFromJson.l = (j.lht.replace('mm','').trim());
        if (j.color) outFromJson.c = ({Solid:'s',Custom:'c'}[j.color] || 's');
        if (j.sc)  outFromJson.sc = j.sc;
        if (j.tcc) outFromJson.tcc = j.tcc;
        if (j.tvc) outFromJson.tvc = j.tvc;
        if (j.tuc) outFromJson.tuc = j.tuc;
        if (j.bc)  outFromJson.bc  = j.bc;
        if (j.sp)  outFromJson.sp  = j.sp;
        return outFromJson;
      } catch (e) {
        console.warn('JSON cfg parse failed, falling back to pairs:', e);
      }
    }
    const out = {};
    trimmed.split(';').forEach(pair => {
      const [k, v] = pair.split('=');
      if (k) out[k] = v;
    });
    return out;
  }

  function refreshColorMenusBasedOnCurrentSpec() {
    const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';
    const style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim() || 'ZS/ZS';
    const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim() || 'Solid';

    const [topSpec, bottomSpec] = style.includes('/') ? style.split('/') : [style, style];
    const upperSize = (typeof getSelectedUpperSize === 'function' ? getSelectedUpperSize() : null);
    const lowerSize = (typeof getSelectedLowerSize === 'function' ? getSelectedLowerSize() : null);

    const topSpecData = i9_menu?.specs?.[topSpec];
    const bottomSpecData = i9_menu?.specs?.[bottomSpec];

    const show = (groupName, shouldShow) => {
      const el = document.querySelector(`[data-group="${groupName}"]`);
      if (el) el.style.display = shouldShow ? 'block' : 'none';
    };

    const isSolid = (colorMode === 'Solid');
    const showTop = (position === 'both' || position === 'top');
    const showBottom = (position === 'both' || position === 'bottom');

    let hasTopCap   = !!topSpecData?.pictures?.hs_top_cap_color;
    let hasTopCover = !!topSpecData?.pictures?.hs_top_cover_color && !!topSpecData?.heights;
    let hasTopCup   = !!topSpecData?.pictures?.hs_top_cup_color && !!(upperSize && topSpecData?.pictures?.hs_top_cup_color?.[upperSize]);
    let hasBottomCup= !!bottomSpecData?.pictures?.hs_bottom_cup_color && !!(lowerSize && bottomSpecData?.pictures?.hs_bottom_cup_color?.[lowerSize]);

    show('solid color', isSolid);
    show('top cap color',   !isSolid && showTop    && hasTopCap);
    show('top cover color', !isSolid && showTop    && hasTopCover);
    show('top cup color',   !isSolid && showTop    && hasTopCup);
    show('bottom cup color',!isSolid && showBottom && hasBottomCup);
  }

  function waitForPriceNode(timeoutMs = 1500) {
    return new Promise(resolve => {
      const node = document.querySelector('[id^="Price"] .f-price-item--regular');
      if (node) return resolve(node);
      const obs = new MutationObserver(() => {
        const n = document.querySelector('[id^="Price"] .f-price-item--regular');
        if (n) { obs.disconnect(); resolve(n); }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => { obs.disconnect(); resolve(null); }, timeoutMs);
    });
  }

  async function applyMenuState(cfgStr) {
    if (!cfgStr) return;
    isRestoring = true;
    const state = decodeMenuState(cfgStr);

    // 1) Position
    let position;
    if (state.p === 't') position = 'Top';
    else if (state.p === 'd') position = 'Bottom';
    else position = 'Both';
    clickOption('position', position);

    if (typeof updateStyleButtonsForPosition === 'function') {
      updateStyleButtonsForPosition(position.toLowerCase());
    }

    // 2) Style
    let styleLabel = StyleFromCode[state.s || 'zz'] || 'ZS/ZS';
    if (position !== 'Both' && styleLabel.includes('/')) {
      styleLabel = styleLabel.split('/')[0];
    }
    clickOption('style', styleLabel);

    if (typeof updateMenusForSpec === 'function') {
      updateMenusForSpec(styleLabel, position.toLowerCase());
    }

    // 3) Height & bores
    if (state.h) clickOption('top cover height', `${state.h}mm`);
    if (state.u) clickOption('upper headtube bore', `${state.u}mm`);
    if (state.l) clickOption('lower headtube bore', `${state.l}mm`);
    if (state.sp === 'y') clickOption('specialized frame', 'Yes');

    // 4) Color mode
    const colorMode = ColorModeFromCode[state.c || 's'] || 'Solid';
    clickOption('color', colorMode);
    if (typeof updateColorMenus === 'function') {
      updateColorMenus(colorMode, position.toLowerCase());
    }
    refreshColorMenusBasedOnCurrentSpec();

    // 5) Select colors by ID (fire change)
    if (colorMode === 'Solid' && state.sc) {
      setSelectByColorId('solid-color', state.sc, true);
    } else if (colorMode === 'Custom') {
      if (state.tcc) setSelectByColorId('top-cap-color', state.tcc, true);
      if (state.tvc) setSelectByColorId('top-cover-color', state.tvc, true);
      if (state.tuc) setSelectByColorId('top-cup-color', state.tuc, true);
      if (state.bc)  setSelectByColorId('bottom-cup-color', state.bc, true);
    }

    if (typeof drawHeadsetToCanvas === 'function') drawHeadsetToCanvas();
    await waitForPriceNode(1500);
    if (typeof updateSelectedVariantId === 'function') updateSelectedVariantId();

    // keep URL-ready var in sync
    currentCfgEncoded = encodeURIComponent(cfgStr);
    window.currentCfgEncoded = currentCfgEncoded;

    isRestoring = false;
  }

  function scheduleSaveToUrl() {
    if (isRestoring) return; // don't write URL during restore
    clearTimeout(saveTimer);
    saveTimer = setTimeout(() => {
      const cfg = encodeMenuState();
      currentCfgEncoded = encodeURIComponent(cfg); // always have URL-safe value
      window.currentCfgEncoded = currentCfgEncoded;

      const url = new URL(window.location.href);
      url.searchParams.set('cfg', cfg); // let URLSearchParams encode it
      window.history.replaceState({}, '', url.toString());
    }, 120);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('.option-button')) {
      scheduleSaveToUrl();
    }
  }, true);

  document.addEventListener('change', (e) => {
    if (e.target.matches('.styled-dropdown')) {
      scheduleSaveToUrl();
    }
  }, true);

  // On first load, add ?cfg=... to the URL if it is missing.
  document.addEventListener('DOMContentLoaded', () => {
    try {
      const url = new URL(window.location.href);
      const raw = url.searchParams.get('cfg');

      if (raw) {
        // If a cfg exists, apply it after your main init runs
        setTimeout(() => { applyMenuState(raw); }, 0);
        return;
      }

      // No cfg -> compute from current UI and add it to the URL
      setTimeout(() => {
        const initial = encodeMenuState();               // e.g. "p=b;s=zz;h=5;u=44;l=56;c=s;sc=14"
        currentCfgEncoded = encodeURIComponent(initial); // store URL-safe version
        window.currentCfgEncoded = currentCfgEncoded;    // expose globally

        const u = new URL(window.location.href);
        u.searchParams.set('cfg', initial);              // preserves other query params
        window.history.replaceState({}, '', u.toString());
      }, 0);
    } catch (err) {
      console.warn('State restore failed:', err);
      isRestoring = false;
    }
  });

  // ---- Minimal API for debugging / programmatic use ----
  window.i9State = {
    encode: () => encodeMenuState(),
    apply: (s) => applyMenuState(s),
    getEncoded: () => currentCfgEncoded
  };
})();









// let selectedVariantId = null;
// const I9_HEADSET_QUOTE_CACHE_TTL_MS = 30000;
// const I9_HEADSET_QUOTE_CACHE_MAX = 50;
// const I9_HEADSET_VAT_CACHE_TTL_MS = 3600000;

// function i9_get_headset_context() {
//   const ctx = window.I9_HEADSET_CONTEXT;
//   return (ctx && typeof ctx === 'object') ? ctx : {};
// }

// function i9_get_storefront_currency_code() {
//   const ctx = i9_get_headset_context();
//   return String(
//     ctx.currency_code ||
//     window?.Shopify?.currency?.active ||
//     'USD'
//   ).toUpperCase();
// }

// function i9_get_storefront_country_code() {
//   const ctx = i9_get_headset_context();
//   const raw = ctx.country_code || window?.Shopify?.country || '';
//   return raw ? String(raw).toUpperCase() : '';
// }

// function i9_get_storefront_country_name() {
//   const ctx = i9_get_headset_context();
//   const raw = ctx.country_name || '';
//   return raw ? String(raw) : '';
// }

// function i9_get_storefront_currency_rate() {
//   const rate = Number(window?.Shopify?.currency?.rate);
//   return Number.isFinite(rate) && rate > 0 ? rate : null;
// }

// function i9_normalize_price_tier(raw) {
//   const v = String(raw || '').toLowerCase().replace(/[\s_-]+/g, '');
//   if (['oem3', 'oemtier3'].includes(v)) return 'oem3';
//   if (['oem2', 'oemtier2'].includes(v)) return 'oem2';
//   if (['oem1', 'oemtier1'].includes(v)) return 'oem1';
//   if (['wh2', 'wholesale2', 'tier2'].includes(v)) return 'wh2';
//   if (['wh1', 'wholesale1', 'tier1', 'wholesale', 'wh'].includes(v)) return 'wh1';
//   return 'retail';
// }

// function i9_get_active_price_tier() {
//   const explicit = String(window?.I9_PRICE_TIER || '').trim().toLowerCase();
//   if (explicit) return i9_normalize_price_tier(explicit);

//   const tags = Array.isArray(i9CustomerTags) ? i9CustomerTags : [];
//   const blob = tags.map(t => String(t || '').toLowerCase()).join(' ');
//   if (/(^|[^a-z0-9])(oem|oe)[\s_-]*3([^a-z0-9]|$)/.test(blob)) return 'oem3';
//   if (/(^|[^a-z0-9])(oem|oe)[\s_-]*2([^a-z0-9]|$)/.test(blob)) return 'oem2';
//   if (/(^|[^a-z0-9])(oem|oe)[\s_-]*1([^a-z0-9]|$)/.test(blob)) return 'oem1';
//   if (/(^|[^a-z0-9])(wholesale|dealer|wh|tier)[\s_-]*2([^a-z0-9]|$)/.test(blob)) return 'wh2';
//   if (/(^|[^a-z0-9])(wholesale|dealer|wh|tier)[\s_-]*1([^a-z0-9]|$)/.test(blob)) return 'wh1';

//   if (i9CustomerIsB2B && String(window?.I9_DEFAULT_B2B_TIER || '').trim() !== '') {
//     return i9_normalize_price_tier(window.I9_DEFAULT_B2B_TIER);
//   }
//   return 'retail';
// }

// function i9_get_headset_shopper_context() {
//   const tier = i9_get_active_price_tier();
//   const currencyCode = i9_get_storefront_currency_code();
//   const countryCode = i9_get_storefront_country_code();
//   const countryName = i9_get_storefront_country_name();
//   const fxRate = i9_get_storefront_currency_rate();
//   const includeVat = (currencyCode === 'EUR' && tier === 'retail');
//   return {
//     response_scope: 'shopper',
//     price_tier: tier,
//     currency_code: currencyCode,
//     country_code: countryCode,
//     country_name: countryName,
//     currency_rate: fxRate,
//     display_vat_inclusive: includeVat ? 1 : 0
//   };
// }

// function i9_format_price_for_currency(price, currencyCode) {
//   const locale = currencyCode === 'EUR' ? 'de-DE' : (currencyCode === 'CAD' ? 'en-CA' : undefined);
//   return new Intl.NumberFormat(locale, {
//     style: 'currency',
//     currency: currencyCode,
//     currencyDisplay: 'symbol',
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//     useGrouping: false
//   }).format(price);
// }

// function i9_get_headset_price_nodes() {
//   const nodes = Array.from(document.querySelectorAll('.f-price-item'));
//   if (nodes.length > 0) return nodes;
//   const regularNode = document.querySelector('[id^="Price"] .f-price-item--regular');
//   return regularNode ? [regularNode] : [];
// }

// function i9_get_headset_price_host() {
//   return document.querySelector('[id^="Price"]') || i9_get_headset_price_nodes()[0]?.parentElement || null;
// }

// function i9_ensure_headset_tax_note() {
//   let note = document.getElementById('i9HeadsetTaxNote');
//   if (note) return note;
//   const host = i9_get_headset_price_host();
//   if (!host) return null;
//   note = document.createElement('p');
//   note.id = 'i9HeadsetTaxNote';
//   note.className = 'i9-headset-tax-note';
//   note.hidden = true;
//   host.insertAdjacentElement('afterend', note);
//   return note;
// }

// function i9_release_headset_price_gate() {
//   document.documentElement.classList.remove('i9-headset-price-pending');
// }

// function i9_format_vat_rate(value) {
//   const rate = Number(value);
//   if (!Number.isFinite(rate)) return '';
//   return Number.isInteger(rate) ? String(rate) : String(rate).replace(/\.0+$/, '').replace(/(\.\d*?)0+$/, '$1');
// }

// function i9_requires_final_headset_price() {
//   const shopperContext = i9_get_headset_shopper_context();
//   return (
//     shopperContext.currency_code === 'EUR' &&
//     shopperContext.price_tier === 'retail' &&
//     shopperContext.display_vat_inclusive === 1
//   );
// }

// function i9_apply_headset_vat_context(info) {
//   const ctx = Object.assign({}, window.I9_HEADSET_CONTEXT || {});
//   if (info && typeof info === 'object') {
//     [
//       'country_code',
//       'country_name',
//       'country_region',
//       'vat_rate',
//       'vat_source',
//       'display_vat_inclusive',
//       'vat_included',
//       'notice'
//     ].forEach((key) => {
//       if (Object.prototype.hasOwnProperty.call(info, key) && info[key] !== undefined && info[key] !== null && info[key] !== '') {
//         ctx[key] = info[key];
//       }
//     });
//     window.I9_HEADSET_CONTEXT = ctx;
//   }

//   const note = i9_ensure_headset_tax_note();
//   if (!note) return;

//   const shopperContext = i9_get_headset_shopper_context();
//   const vatRate = Number(info?.vat_rate ?? ctx.vat_rate);
//   const countryRegion = String(info?.country_region || ctx.country_region || '').toLowerCase();
//   const vatIncluded = (info && typeof info.vat_included === 'boolean')
//     ? info.vat_included
//     : (
//       shopperContext.currency_code === 'EUR' &&
//       shopperContext.price_tier === 'retail' &&
//       shopperContext.display_vat_inclusive === 1 &&
//       countryRegion === 'eu' &&
//       Number.isFinite(vatRate)
//     );

//   if (!vatIncluded || !Number.isFinite(vatRate)) {
//     note.hidden = true;
//     note.textContent = '';
//     return;
//   }

//   const countryName = String(info?.country_name || ctx.country_name || '').trim();
//   const notice = String(info?.notice || ctx.notice || '').trim();
//   note.textContent = notice || `Price includes ${i9_format_vat_rate(vatRate)}% VAT${countryName ? ` for ${countryName}` : ''}.`;
//   note.hidden = false;
// }

// function i9_set_headset_price_pending(isPending) {
//   const strictFinalPrice = i9_requires_final_headset_price();
//   document.documentElement.classList.toggle('i9-headset-price-pending', strictFinalPrice && isPending);
//   i9_get_headset_price_nodes().forEach((el) => {
//     if (isPending) {
//       el.style.opacity = strictFinalPrice ? '0' : '0.6';
//       el.style.visibility = strictFinalPrice ? 'hidden' : '';
//       el.setAttribute('aria-busy', 'true');
//       return;
//     }
//     el.style.opacity = '';
//     el.style.visibility = '';
//     el.removeAttribute('aria-busy');
//   });

//   const note = document.getElementById('i9HeadsetTaxNote');
//   if (note && strictFinalPrice && isPending) {
//     note.style.opacity = '0';
//     note.hidden = true;
//   } else if (note) {
//     note.style.opacity = '';
//   }
// }

// function i9_render_headset_price_value(price) {
//   if (!Number.isFinite(price)) return;
//   const priceText = i9_format_price_for_currency(Number(price), i9_get_storefront_currency_code());

//   const regularNode = document.querySelector('[id^="Price"] .f-price-item--regular');
//   if (regularNode) regularNode.textContent = priceText;
//   document.querySelectorAll('.f-price-item').forEach((el) => {
//     el.textContent = priceText;
//   });
//   i9_set_headset_price_pending(false);
// }

// document.addEventListener("DOMContentLoaded", function () {
//   const styleOptionsByPosition = {
//     both: ["ZS/ZS", "IS/IS", "EC/EC", "ZS/EC"],
//     top: ["ZS", "IS", "EC"],
//     bottom: ["ZS", "IS", "EC"]
//   };
//   const i9HeadsetQuoteCache = new Map();
//   const i9HeadsetDisplayFactorCache = new Map();
//   let i9HeadsetQuoteAbort = null;
//   let i9HeadsetQuoteSeq = 0;
//   let i9QuoteDebounceTimer = null;

//   function getHeadsetVatInfoCacheKey() {
//     const ctx = i9_get_headset_shopper_context();
//     return JSON.stringify({
//       price_tier: ctx.price_tier,
//       currency_code: ctx.currency_code,
//       country_code: ctx.country_code,
//       country_name: ctx.country_name,
//       display_vat_inclusive: ctx.display_vat_inclusive
//     });
//   }

//   function getCachedHeadsetVatInfo(key) {
//     if (!key || !window.sessionStorage) return null;
//     try {
//       const raw = window.sessionStorage.getItem(`i9_headset_vat:${key}`);
//       if (!raw) return null;
//       const parsed = JSON.parse(raw);
//       if (!parsed || typeof parsed !== 'object') return null;
//       if ((Date.now() - Number(parsed.ts || 0)) > I9_HEADSET_VAT_CACHE_TTL_MS) {
//         window.sessionStorage.removeItem(`i9_headset_vat:${key}`);
//         return null;
//       }
//       return parsed.data || null;
//     } catch (_) {
//       return null;
//     }
//   }

//   function setCachedHeadsetVatInfo(key, data) {
//     if (!key || !data || typeof data !== 'object' || !window.sessionStorage) return;
//     try {
//       window.sessionStorage.setItem(`i9_headset_vat:${key}`, JSON.stringify({
//         ts: Date.now(),
//         data
//       }));
//     } catch (_) {}
//   }

//   async function bootstrapHeadsetVatInfo() {
//     const ctx = i9_get_headset_shopper_context();
//     if (ctx.currency_code !== 'EUR' || ctx.price_tier !== 'retail') {
//       i9_apply_headset_vat_context({ vat_included: false, display_vat_inclusive: ctx.display_vat_inclusive });
//       return;
//     }

//     const key = getHeadsetVatInfoCacheKey();
//     const cached = getCachedHeadsetVatInfo(key);
//     if (cached) {
//       i9_apply_headset_vat_context(cached);
//       return;
//     }

//     const payload = {
//       type: 'country_vat_info',
//       response_scope: ctx.response_scope,
//       price_tier: ctx.price_tier,
//       currency_code: ctx.currency_code,
//       country_code: ctx.country_code,
//       country_name: ctx.country_name,
//       display_vat_inclusive: ctx.display_vat_inclusive
//     };
//     if (ctx.currency_rate !== null) payload.currency_rate = ctx.currency_rate;
//     if (window.I9_STORE) payload.store = window.I9_STORE;

//     const base = (window.I9_API_BUILD_URL || window.I9_API_BASE || 'https://api.i9.bike').replace(/\/$/, '');
//     try {
//       const res = await fetch(`${base}`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       const data = await res.json().catch(() => null);
//       if (!data || data.ok !== true) return;
//       setCachedHeadsetVatInfo(key, data);
//       i9_apply_headset_vat_context(data);
//     } catch (err) {
//       console.warn('Headset VAT bootstrap failed', err);
//     }
//   }

//   function setupButtonGroupInteraction(groupName) {
//     const group = document.querySelector(`[data-group="${groupName}"] .button-group`);
//     const subtitle = document.querySelector(`[data-group="${groupName}"] .section-subtitle`);
//     if (!group) return;

//     group.addEventListener('click', e => {
//       const btn = e.target.closest('.option-button');
//       if (!btn) return;
//       group.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
//       btn.classList.add('selected');
//       subtitle.textContent = btn.textContent.trim();
//       drawHeadsetToCanvas();
//       updateSelectedVariantId();
//     });
//   }

//   ['top cover height', 'upper headtube bore', 'lower headtube bore'].forEach(setupButtonGroupInteraction);

//   function updateColorMenus(colorMode, position) {
//     const show = (groupName, shouldShow) => {
//       const section = document.querySelector(`[data-group="${groupName}"]`);
//       if (section) section.style.display = shouldShow ? 'block' : 'none';
//     };

//     const isSolid = colorMode === 'Solid';
//     const showTop = position === 'top' || position === 'both';
//     const showBottom = position === 'bottom' || position === 'both';

//     show('solid color', isSolid);
//     show('top cap color', !isSolid && showTop);
//     show('top cover color', !isSolid && showTop);
//     show('top cup color', !isSolid && showTop);
//     show('bottom cup color', !isSolid && showBottom);

//     drawHeadsetToCanvas();
//   }

//   function updateStyleButtonsForPosition(position) {
//     const group = document.querySelector('[data-group="style"] .button-group');
//     const subtitle = document.querySelector('[data-group="style"] .section-subtitle');
//     if (!group) return;
//     const styles = styleOptionsByPosition[position] || [];
//     group.innerHTML = '';
//     styles.forEach((style, index) => {
//       const btn = document.createElement('button');
//       btn.className = 'option-button' + (index === 0 ? ' selected' : '');
//       btn.textContent = style;
//       group.appendChild(btn);
//       btn.addEventListener('click', () => {
//         group.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
//         btn.classList.add('selected');
//         if (subtitle) subtitle.textContent = style;
//         updateMenusForSpec(style, position);
//         drawHeadsetToCanvas();
//         updateSelectedVariantId();
//       });
//       if (index === 0 && subtitle) subtitle.textContent = style;
//     });
//   }

//   function updateMenusForSpec(spec, overridePosition = null) {
//     const positionSelected = overridePosition || document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';
//     let topSpecData = null;
//     let bottomSpecData = null;

//     if (spec === 'EC/EC') {
//       topSpecData = i9_menu.specs['EC'];
//       bottomSpecData = i9_menu.specs['EC'];
//     } else if (spec === 'ZS/EC') {
//       topSpecData = i9_menu.specs['ZS'];
//       bottomSpecData = i9_menu.specs['EC'];
//     } else if (spec === 'ZS/ZS') {
//       topSpecData = i9_menu.specs['ZS'];
//       bottomSpecData = i9_menu.specs['ZS'];
//     } else if (spec === 'IS/IS') {
//       topSpecData = i9_menu.specs['IS'];
//       bottomSpecData = i9_menu.specs['IS'];
//     } else {
//       topSpecData = i9_menu.specs[spec];
//       bottomSpecData = i9_menu.specs[spec];
//     }

//     const topHeights = topSpecData.heights || {};
//     toggleSection('top cover height', Object.keys(topHeights).length > 0 && (positionSelected === 'top' || positionSelected === 'both'));
//     if (Object.keys(topHeights).length > 0) {
//       updateButtonGroup('top cover height', Object.keys(topHeights).map(h => h + 'mm'));
//     }

//     const upper = topSpecData.bore_size?.upper || [];
//     toggleSection('upper headtube bore', upper.length > 0 && (positionSelected === 'top' || positionSelected === 'both'));
//     if (upper.length > 0) {
//       updateButtonGroup('upper headtube bore', upper.map(b => b.size + 'mm'));
//     }

//     const lower = bottomSpecData.bore_size?.lower || [];
//     toggleSection('lower headtube bore', lower.length > 0 && (positionSelected === 'bottom' || positionSelected === 'both'));
//     if (lower.length > 0) {
//       updateButtonGroup('lower headtube bore', lower.map(b => b.size + 'mm'));
//     }
//   }

//   function toggleSection(groupName, shouldShow) {
//     const section = document.querySelector(`[data-group="${groupName}"]`);
//     if (section) section.style.display = shouldShow ? 'block' : 'none';
//   }

//   function updateButtonGroup(groupName, values) {
//     const group = document.querySelector(`[data-group="${groupName}"] .button-group`);
//     const subtitle = document.querySelector(`[data-group="${groupName}"] .section-subtitle`);
//     if (!group) return;
//     group.innerHTML = '';
//     values.forEach((val, i) => {
//       const btn = document.createElement('button');
//       btn.className = 'option-button' + (i === 0 ? ' selected' : '');
//       btn.textContent = val;
//       group.appendChild(btn);
//       btn.addEventListener('click', () => {
//         group.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
//         btn.classList.add('selected');
//         if (subtitle) subtitle.textContent = val;
//         drawHeadsetToCanvas();
//         updateSelectedVariantId();
//       });
//       if (i === 0 && subtitle) subtitle.textContent = val;
//     });
//   }

//   function updateSelectedVariantId() {
//     const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim();
//     let style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
//     let colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim();

//     if (!position || !style || !colorMode) {
//       selectedVariantId = null;
//       return;
//     }

//     if (style === 'ZS') style = 'ZS/ZS';
//     if (style === 'IS') style = 'IS/IS';
//     if (style === 'EC') style = 'EC/EC';

//     if (position === 'Bottom') {
//       colorMode = 'Solid';
//       const allColorBtns = document.querySelectorAll('[data-group="color"] .button-group .option-button');
//       allColorBtns.forEach(btn => btn.classList.remove('selected'));
//       const solidBtn = Array.from(allColorBtns).find(btn => btn.textContent.trim() === 'Solid');
//       if (solidBtn) solidBtn.classList.add('selected');
//     }

//     const match = Array.isArray(productVariants)
//       ? productVariants.find(v =>
//           v.option1?.trim() === position &&
//           v.option2?.trim() === style &&
//           v.option3?.trim() === colorMode
//         )
//       : null;

//     if (match) {
//       selectedVariantId = match.id;
//     } else {
//       selectedVariantId = null;
//     }

//     scheduleHeadsetQuoteRefresh();
//   }

//   function buildHeadsetQuotePayload() {
//     if (typeof buildSenderFromMenu !== 'function') return null;
//     const ass = buildSenderFromMenu();
//     if (!ass || !ass.position) return null;
//     const ctx = i9_get_headset_shopper_context();
//     const payload = {
//       type: 'quote_headset',
//       ass,
//       response_scope: ctx.response_scope,
//       price_tier: ctx.price_tier,
//       currency_code: ctx.currency_code,
//       country_code: ctx.country_code,
//       country_name: ctx.country_name,
//       display_vat_inclusive: ctx.display_vat_inclusive
//     };
//     if (ctx.currency_rate !== null) payload.currency_rate = ctx.currency_rate;
//     if (window.I9_STORE) payload.store = window.I9_STORE;
//     return payload;
//   }

//   function headsetQuoteCacheKey(payload) {
//     if (!payload) return '';
//     const copy = { ...payload };
//     delete copy.type;
//     delete copy.store;
//     return JSON.stringify(copy);
//   }

//   function getCachedHeadsetQuote(key) {
//     if (!key || !i9HeadsetQuoteCache.has(key)) return null;
//     const hit = i9HeadsetQuoteCache.get(key);
//     if (!hit || typeof hit !== 'object') return null;
//     if ((Date.now() - Number(hit.ts || 0)) > I9_HEADSET_QUOTE_CACHE_TTL_MS) {
//       i9HeadsetQuoteCache.delete(key);
//       return null;
//     }
//     return hit.data || null;
//   }

//   function setCachedHeadsetQuote(key, data) {
//     if (!key || !data || typeof data !== 'object') return;
//     i9HeadsetQuoteCache.set(key, { ts: Date.now(), data });
//     while (i9HeadsetQuoteCache.size > I9_HEADSET_QUOTE_CACHE_MAX) {
//       const first = i9HeadsetQuoteCache.keys().next().value;
//       if (!first) break;
//       i9HeadsetQuoteCache.delete(first);
//     }
//   }

//   function getVariantFallbackPrice() {
//     const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim();
//     let style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
//     let colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim();
//     if (!position || !style || !colorMode) return null;

//     if (style === 'ZS') style = 'ZS/ZS';
//     if (style === 'IS') style = 'IS/IS';
//     if (style === 'EC') style = 'EC/EC';
//     if (position === 'Bottom') colorMode = 'Solid';

//     const hit = Array.isArray(productVariants)
//       ? productVariants.find(v =>
//           v.option1?.trim() === position &&
//           v.option2?.trim() === style &&
//           v.option3?.trim() === colorMode
//         )
//       : null;
//     if (!hit) return null;
//     const n = Number(hit.price) / 100;
//     return Number.isFinite(n) ? n : null;
//   }

//   function getHeadsetPricingContextKey() {
//     const ctx = i9_get_headset_shopper_context();
//     return JSON.stringify({
//       price_tier: ctx.price_tier,
//       currency_code: ctx.currency_code,
//       country_code: ctx.country_code,
//       display_vat_inclusive: ctx.display_vat_inclusive,
//       currency_rate: ctx.currency_rate
//     });
//   }

//   function normalizeHeadsetColorName(value) {
//     const raw = String(value || '').trim();
//     if (!raw) return '';
//     if (raw.toUpperCase() === 'NA') return 'NA';
//     return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
//   }

//   function getHeadsetPriceEntryValue(entry) {
//     if (entry === null || entry === undefined) return null;
//     if (Array.isArray(entry)) {
//       const first = Number(entry[0]);
//       return Number.isFinite(first) ? first : null;
//     }
//     const direct = Number(entry);
//     return Number.isFinite(direct) ? direct : null;
//   }

//   function isHeadsetMixedConfig(ass) {
//     if (!ass || typeof ass !== 'object') return false;
//     if (ass.position === 'both') {
//       const colors = [
//         normalizeHeadsetColorName(ass.top_cap_color),
//         normalizeHeadsetColorName(ass.top_cover_color),
//         normalizeHeadsetColorName(ass.top_cup_color),
//         normalizeHeadsetColorName(ass.bottom_cup_color)
//       ].filter((color) => color && color !== 'NA');
//       return new Set(colors).size > 1;
//     }
//     if (ass.position === 'top') {
//       const colors = [
//         normalizeHeadsetColorName(ass.top_cap_color),
//         normalizeHeadsetColorName(ass.top_cover_color),
//         normalizeHeadsetColorName(ass.top_cup_color)
//       ].filter((color) => color && color !== 'NA');
//       return new Set(colors).size > 1;
//     }
//     return false;
//   }

//   function getLocalHeadsetBasePriceFromAss(ass) {
//     if (!ass || typeof ass !== 'object') return null;
//     const topSpecData = ass.top_spec ? i9_menu?.specs?.[ass.top_spec] : null;
//     const bottomSpecData = ass.bottom_spec ? i9_menu?.specs?.[ass.bottom_spec] : null;
//     const charges = topSpecData?.charges || bottomSpecData?.charges || {};
//     const bothDiscount = Number(charges.both_discount || 0);
//     const colorMixBoth = Number(charges.color_mix_both || 0);
//     const colorMixTop = Number(charges.color_mix_top || 0);
//     const mixed = isHeadsetMixedConfig(ass);

//     if (ass.position === 'both') {
//       const topPrice = getHeadsetPriceEntryValue(
//         topSpecData?.prices?.top?.[String(ass.upper_headtube_bore)]?.[String(ass.height)]
//       );
//       const bottomPrice = getHeadsetPriceEntryValue(
//         bottomSpecData?.prices?.bottom?.[String(ass.lower_headtube_bore)]
//       );
//       if (!Number.isFinite(topPrice) || !Number.isFinite(bottomPrice)) return null;
//       return topPrice + bottomPrice - bothDiscount + (mixed ? colorMixBoth : 0);
//     }

//     if (ass.position === 'top') {
//       const topPrice = getHeadsetPriceEntryValue(
//         topSpecData?.prices?.top?.[String(ass.upper_headtube_bore)]?.[String(ass.height)]
//       );
//       if (!Number.isFinite(topPrice)) return null;
//       return topPrice + (mixed ? colorMixTop : 0);
//     }

//     if (ass.position === 'bottom') {
//       const bottomPrice = getHeadsetPriceEntryValue(
//         bottomSpecData?.prices?.bottom?.[String(ass.lower_headtube_bore)]
//       );
//       return Number.isFinite(bottomPrice) ? bottomPrice : null;
//     }

//     return null;
//   }

//   function cacheHeadsetDisplayFactor(payload, data) {
//     const displayPrice = Number(data?.display_price);
//     const localBase = getLocalHeadsetBasePriceFromAss(payload?.ass);
//     if (!Number.isFinite(displayPrice) || !Number.isFinite(localBase) || localBase <= 0) return;
//     i9HeadsetDisplayFactorCache.set(getHeadsetPricingContextKey(), displayPrice / localBase);
//   }

//   function getImmediateHeadsetEstimatedPrice(payload) {
//     if (i9_requires_final_headset_price()) return null;

//     const localBase = getLocalHeadsetBasePriceFromAss(payload?.ass);
//     if (!Number.isFinite(localBase)) return null;

//     const factor = Number(i9HeadsetDisplayFactorCache.get(getHeadsetPricingContextKey()));
//     if (Number.isFinite(factor) && factor > 0) {
//       return Math.round(localBase * factor * 100) / 100;
//     }

//     if (canUseVariantFallbackPrice()) {
//       const fallbackVariant = getVariantFallbackPrice();
//       if (Number.isFinite(fallbackVariant)) return fallbackVariant;
//     }

//     return null;
//   }

//   function renderImmediateHeadsetEstimate(payload) {
//     const estimated = getImmediateHeadsetEstimatedPrice(payload);
//     if (!Number.isFinite(estimated)) return false;
//     i9_render_headset_price_value(estimated);
//     return true;
//   }

//   function canUseVariantFallbackPrice() {
//     const shopperContext = i9_get_headset_shopper_context();
//     return shopperContext.price_tier === 'retail' && shopperContext.currency_code === 'USD';
//   }

//   function tryRenderVariantFallbackPrice() {
//     if (i9_requires_final_headset_price()) return false;
//     if (!canUseVariantFallbackPrice()) return false;
//     const fallbackVariant = getVariantFallbackPrice();
//     if (!Number.isFinite(fallbackVariant)) return false;
//     i9_render_headset_price_value(fallbackVariant);
//     return true;
//   }

// function renderHeadsetQuotePrice(data) {
//   i9_apply_headset_vat_context(data);
//   const direct = Number(data?.display_price);
//   if (Number.isFinite(direct)) {
//     i9_render_headset_price_value(direct);
//     i9_release_headset_price_gate();
//     return true;
//   }
//   const bag = data?.prices;
//   const fallbackBag = (bag && typeof bag === 'object') ? Number(bag.display) : null;
//   if (Number.isFinite(fallbackBag)) {
//     i9_render_headset_price_value(fallbackBag);
//     i9_release_headset_price_gate();
//     return true;
//   }
//   return tryRenderVariantFallbackPrice();
// }

//   async function refreshHeadsetQuote() {
//     const payload = buildHeadsetQuotePayload();
//     if (!payload) return;

//     const key = headsetQuoteCacheKey(payload);
//     const cached = getCachedHeadsetQuote(key);
//     if (cached) {
//       if (!renderHeadsetQuotePrice(cached)) i9_set_headset_price_pending(false);
//       return;
//     }

//     i9_set_headset_price_pending(true);

//     if (i9HeadsetQuoteAbort) {
//       try { i9HeadsetQuoteAbort.abort(); } catch (_) {}
//     }

//     const ctrl = new AbortController();
//     i9HeadsetQuoteAbort = ctrl;
//     const seq = ++i9HeadsetQuoteSeq;
//     const base = (window.I9_API_BUILD_URL || window.I9_API_BASE || 'https://api.i9.bike').replace(/\/$/, '');

//     try {
//       const res = await fetch(`${base}`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//         signal: ctrl.signal
//       });
//       const data = await res.json().catch(() => null);
//       if (!data || data.ok !== true) {
//         if (!tryRenderVariantFallbackPrice()) {
//           if (i9_requires_final_headset_price()) {
//             i9_release_headset_price_gate();
//           } else {
//             i9_set_headset_price_pending(false);
//           }
//         }
//         return;
//       }
//       if (seq !== i9HeadsetQuoteSeq) return;
//       setCachedHeadsetQuote(key, data);
//       cacheHeadsetDisplayFactor(payload, data);
//       if (!renderHeadsetQuotePrice(data)) i9_set_headset_price_pending(false);
//     } catch (err) {
//       if (err && err.name === 'AbortError') return;
//       if (!tryRenderVariantFallbackPrice()) {
//         if (i9_requires_final_headset_price()) {
//           i9_release_headset_price_gate();
//         } else {
//           i9_set_headset_price_pending(false);
//         }
//       }
//       console.warn('Headset quote pricing failed', err);
//     }
//   }

//   function scheduleHeadsetQuoteRefresh() {
//     clearTimeout(i9QuoteDebounceTimer);
//     const payload = buildHeadsetQuotePayload();
//     const key = payload ? headsetQuoteCacheKey(payload) : '';
//     if (key && !getCachedHeadsetQuote(key) && !renderImmediateHeadsetEstimate(payload)) {
//       i9_set_headset_price_pending(true);
//     }
//     i9QuoteDebounceTimer = setTimeout(() => {
//       refreshHeadsetQuote();
//     }, 120);
//   }

//   document.querySelectorAll('[data-group="color"] .option-button').forEach(btn => {
//     btn.addEventListener('click', () => {
//       btn.closest('.button-group').querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
//       btn.classList.add('selected');
//       const label = btn.textContent.trim();
//       document.querySelector('[data-group="color"] .section-subtitle').textContent = label;
//       const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';
//       updateColorMenus(label, position);
//       updateSelectedVariantId();
//     });
//   });

//   document.querySelectorAll('[data-group="position"] .option-button').forEach(btn => {
//     btn.addEventListener('click', () => {
//       btn.closest('.button-group').querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
//       btn.classList.add('selected');
//       const label = btn.textContent.trim();
//       document.querySelector('[data-group="position"] .section-subtitle').textContent = label;
//       updateStyleButtonsForPosition(label.toLowerCase());
//       const selectedStyle = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
//       updateMenusForSpec(selectedStyle, label.toLowerCase());
//       const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim();
//       updateColorMenus(colorMode, label.toLowerCase());
//       updateSelectedVariantId();
//     });
//   });

//   function syncSelectSubtitle(selectEl) {
//     const section = selectEl.closest('.section');
//     const subtitle = section?.querySelector('.section-subtitle');
//     const opt = selectEl.options[selectEl.selectedIndex];
//     if (subtitle && opt) subtitle.textContent = opt.textContent.trim();
//   }

//   document.querySelectorAll('.styled-dropdown').forEach(select => {
//     select.addEventListener('change', () => {
//       syncSelectSubtitle(select);
//       drawHeadsetToCanvas();
//       updateSelectedVariantId();
//     });
//     syncSelectSubtitle(select);
//   });

//   updateStyleButtonsForPosition('both');
//   const defaultStyle = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
//   if (defaultStyle) updateMenusForSpec(defaultStyle, 'both');
//   const defaultColor = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim() || 'Solid';
//   updateColorMenus(defaultColor, 'both');
//   drawHeadsetToCanvas();
//   updateSelectedVariantId();
//   bootstrapHeadsetVatInfo();
// });

// // -------------------------
// // Canvas Setup + Drawing
// // -------------------------

// window.addEventListener('load', () => {
//   const mediaGallery = document.querySelector('media-gallery, .product__media-wrapper');
//   if (mediaGallery && !document.getElementById('headset-canvas')) {
//     const canvas = document.createElement('canvas');
//     canvas.id = 'headset-canvas';
//     canvas.width = 600;
//     canvas.height = 600;
//     canvas.style.width = '100%';
//     canvas.style.height = 'auto';
//     canvas.style.display = 'block';
//     mediaGallery.innerHTML = '';
//     mediaGallery.appendChild(canvas);
//     requestAnimationFrame(drawHeadsetToCanvas);
//   }
// });

// function drawHeadsetToCanvas() {
//   const canvas = document.getElementById('headset-canvas');
//   if (!canvas) return;
//   const ctx = canvas.getContext('2d');
//   ctx.fillStyle = "white";
//   ctx.fillRect(0, 0, canvas.width, canvas.height);

//   const style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
//   const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim() || 'Solid';
//   const isSolid = colorMode === 'Solid';
//   const solidColor = document.getElementById('solid-color')?.selectedOptions[0]?.textContent.toLowerCase();
//   const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';

//   const showTop = position === 'top' || position === 'both';
//   const showBottom = position === 'bottom' || position === 'both';

//   const height = getSelectedHeight();
//   const upperSize = getSelectedUpperSize();
//   const lowerSize = getSelectedLowerSize();

//   const topSpec = style.includes('/') ? style.split('/')[0] : style;
//   const bottomSpec = style.includes('/') ? style.split('/')[1] : style;

//   const topSpecData = i9_menu.specs[topSpec];
//   const bottomSpecData = i9_menu.specs[bottomSpec];

//   const imageSources = [];

//   if (showTop && topSpecData?.pictures?.hs_top_cap_color) {
//     const color = isSolid ? solidColor : document.getElementById('top-cap-color')?.selectedOptions[0]?.textContent.toLowerCase();
//     if (color) imageSources.push(`https://api.i9.bike/images/hsv4/${topSpecData.pictures.hs_top_cap_color}/${color}.png`);
//   }

//   if (showTop && topSpecData?.pictures?.hs_top_cover_color?.[height]) {
//     const color = isSolid ? solidColor : document.getElementById('top-cover-color')?.selectedOptions[0]?.textContent.toLowerCase();
//     if (color) imageSources.push(`https://api.i9.bike/images/hsv4/${topSpecData.pictures.hs_top_cover_color[height]}/${color}.png`);
//   }

//   if (showTop) imageSources.push("https://api.i9.bike/images/hsv4/bearings/top.png");

//   if (showTop && topSpecData?.pictures?.hs_top_cup_color?.[upperSize]) {
//     const color = isSolid ? solidColor : document.getElementById('top-cup-color')?.selectedOptions[0]?.textContent.toLowerCase();
//     if (color) imageSources.push(`https://api.i9.bike/images/hsv4/${topSpecData.pictures.hs_top_cup_color[upperSize]}/${color}.png`);
//   }

//   if (showBottom && bottomSpecData?.pictures?.hs_bottom_cup_color?.[lowerSize]) {
//     const color = isSolid ? solidColor : document.getElementById('bottom-cup-color')?.selectedOptions[0]?.textContent.toLowerCase();
//     if (color) imageSources.push(`https://api.i9.bike/images/hsv4/${bottomSpecData.pictures.hs_bottom_cup_color[lowerSize]}/${color}.png`);
//   }

//   if (showBottom) imageSources.push("https://api.i9.bike/images/hsv4/bearings/bottom.png");

//   loadAndDrawStackedImages(ctx, canvas, imageSources);
// }

// function getSelectedHeight() {
//   return document.querySelector('[data-group="top cover height"] .option-button.selected')?.textContent.replace('mm', '').trim() || '5';
// }
// function getSelectedUpperSize() {
//   return document.querySelector('[data-group="upper headtube bore"] .option-button.selected')?.textContent.replace('mm', '').trim() || '44';
// }
// function getSelectedLowerSize() {
//   return document.querySelector('[data-group="lower headtube bore"] .option-button.selected')?.textContent.replace('mm', '').trim() || '56';
// }

// function loadAndDrawStackedImages(ctx, canvas, urls) {
//   const images = [];
//   let loaded = 0;
//   if (urls.length === 0) return;

//   urls.forEach((url, index) => {
//     const img = new Image();
//     img.onload = () => {
//       images[index] = img;
//       loaded++;
//       if (loaded === urls.length) {
//         const padding = 10;
//         const totalHeight = images.reduce((sum, img) => {
//           const scale = canvas.width / img.width;
//           return sum + (img.height * scale) + padding;
//         }, -padding);

//         if (totalHeight > canvas.height) {
//           canvas.height = Math.ceil(totalHeight + 20);
//         }

//         renderStackedImages(ctx, canvas, images);
//       }
//     };
//     img.onerror = () => {
//       loaded++;
//       if (loaded === urls.length) {
//         renderStackedImages(ctx, canvas, images);
//       }
//     };
//     img.src = url;
//   });
// }

// function renderStackedImages(ctx, canvas, images) {
//   const padding = 10;
//   const totalHeight = images.reduce((sum, img) => sum + (canvas.width / img.width * img.height), 0) + (images.length - 1) * padding;
//   let y = (canvas.height - totalHeight) / 2;
//   images.forEach(img => {
//     const scale = canvas.width / img.width;
//     const width = canvas.width;
//     const height = img.height * scale;
//     ctx.drawImage(img, 0, y, width, height);
//     y += height + padding;
//   });
// }

// // ---------- Loading helpers ----------
// function i9ShowLoading(title = 'Working…', desc = 'Please wait.') {
//   const el = document.getElementById('i9Loading');
//   if (!el) return;
//   el.setAttribute('aria-hidden', 'false');
//   const t = document.getElementById('i9LoadingTitle');
//   const d = document.getElementById('i9LoadingDesc');
//   const live = document.getElementById('i9LoadingLive');
//   if (t) t.textContent = title;
//   if (d) d.textContent = desc;
//   if (live) live.textContent = title + ' ' + desc;
//   document.body.style.overflow = 'hidden'; // lock scroll
// }

// function i9UpdateLoading(title, desc) {
//   const t = document.getElementById('i9LoadingTitle');
//   const d = document.getElementById('i9LoadingDesc');
//   const live = document.getElementById('i9LoadingLive');
//   if (t && title) t.textContent = title;
//   if (d && desc)  d.textContent = desc;
//   if (live) live.textContent = (title || t?.textContent || '') + ' ' + (desc || d?.textContent || '');
// }

// function i9HideLoading() {
//   const el = document.getElementById('i9Loading');
//   if (!el) return;
//   el.setAttribute('aria-hidden', 'true');
//   document.body.style.overflow = ''; // unlock scroll
// }

// function i9GetCartSections() {
//   let sections = [];
//   document.documentElement.dispatchEvent(
//     new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
//   );
//   const cartDrawer = document.querySelector('cart-drawer');
//   const mainCart = document.querySelector('cart-items');
//   if (cartDrawer?.getSectionsToRender) {
//     sections = sections.concat(cartDrawer.getSectionsToRender().map((s) => s.id));
//   }
//   if (mainCart?.getSectionsToRender) {
//     sections = sections.concat(mainCart.getSectionsToRender().map((s) => s.section));
//   }
//   return sections;
// }

// function i9GetQuantity(root) {
//   const rootForm = root?.closest?.('form');
//   if (rootForm?.id) {
//     const byForm = document.querySelector(`input[name="quantity"][form="${rootForm.id}"]`);
//     const vForm = parseInt(byForm?.value, 10);
//     if (Number.isFinite(vForm) && vForm > 0) return vForm;
//   }
//   const selectors = [
//     'form[action*="/cart/add"] input[name="quantity"]',
//     'quantity-input input[name="quantity"]',
//     '.quantity__input',
//     'input[name="quantity"]',
//     '.i9wc-quantity input'
//   ];
//   const findAll = (ctx) => {
//     if (!ctx || !ctx.querySelectorAll) return [];
//     const list = [];
//     selectors.forEach((sel) => ctx.querySelectorAll(sel).forEach((el) => list.push(el)));
//     return list;
//   };
//   const pickVisible = (list) => list.find((el) => el && el.offsetParent !== null && !el.disabled) || list[0];

//   const scope =
//     root && (root.closest?.('form') || root.closest?.('[data-product-id]') || root.closest?.('.product') || root);
//   let candidates = findAll(scope);
//   if (!candidates.length) candidates = findAll(document);
//   const input = pickVisible(candidates);
//   const v = parseInt(input?.value, 10);
//   return Number.isFinite(v) && v > 0 ? v : 1;
// }

// async function i9AddVariantToCart(variantId, qty = 1, properties = null) {
//   const addUrl = window.FoxThemeSettings?.routes?.cart_add_url || '/cart/add.js';
//   const sections = i9GetCartSections();
//   const buildFormData = () => {
//     const formData = new FormData();
//     formData.append('id', variantId);
//     formData.append('quantity', qty);
//     if (properties && typeof properties === 'object') {
//       Object.entries(properties).forEach(([key, value]) => {
//         if (value === undefined || value === null || value === '') return;
//         formData.append(`properties[${key}]`, value);
//       });
//     }
//     if (sections.length) {
//       formData.append('sections', sections);
//       formData.append('sections_url', window.location.pathname);
//     }
//     return formData;
//   };

//   let data = {};
//   for (let attempt = 1; attempt <= 5; attempt++) {
//     const res = await fetch(addUrl, {
//       method: 'POST',
//       headers: {
//         Accept: 'application/javascript',
//         'X-Requested-With': 'XMLHttpRequest'
//       },
//       body: buildFormData()
//     });

//     data = await res.json().catch(() => ({}));
//     if (!(data && data.status)) break;

//     const msg = String(data.description || data.message || 'Add to cart failed');
//     const retryable = Number(data.status) === 422 && /(sold out|unavailable|cannot be purchased)/i.test(msg);
//     if (retryable && attempt < 5) {
//       await new Promise((resolve) => setTimeout(resolve, attempt * 500));
//       continue;
//     }

//     const e = new Error(`add.js failed (${data.status}). ${msg}`);
//     e.status = data.status;
//     e.variantId = variantId;
//     throw e;
//   }

//   if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== 'undefined') {
//     window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, data);
//   }
//   return data;
// }

// // ---------- Add to Cart (with progress UI) ----------
// document.addEventListener('click', async (e) => {
//   const btn = e.target.closest('button[type="submit"][name="add"]');
//   if (!btn) return;

//   // block double clicks while busy
//   if (btn.dataset.loading === '1') {
//     e.preventDefault();
//     e.stopPropagation();
//     return;
//   }

//   e.preventDefault();
//   e.stopPropagation();

//   try {
//     btn.dataset.loading = '1';
//     btn.disabled = true;
//     btn.setAttribute('aria-busy', 'true');

//     i9ShowLoading('Building your headset…', 'This can take a few seconds.');
//     var sender = buildSenderFromMenu();
//     const shopperContext = i9_get_headset_shopper_context();

//     // Step 1: make_headset
//     const base = (window.I9_API_BUILD_URL || window.I9_API_BASE || 'https://api.i9.bike').replace(/\/$/, '');
//     const payload = {
//       ass: sender,
//       type: "make_headset",
//       response_scope: shopperContext.response_scope,
//       price_tier: shopperContext.price_tier,
//       currency_code: shopperContext.currency_code,
//       country_code: shopperContext.country_code,
//       country_name: shopperContext.country_name,
//       page_path: window.location.pathname || '/products/headset',
//       display_vat_inclusive: shopperContext.display_vat_inclusive
//     };
//     if (shopperContext.currency_rate !== null) payload.currency_rate = shopperContext.currency_rate;
//     if (window.I9_STORE) payload.store = window.I9_STORE;
//     const makeRes = await fetch(`${base}`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(payload)
//     });

//     let data;
//     try {
//       data = await makeRes.json();
//     } catch {
//       throw new Error('Invalid response from builder.');
//     }

//     if (!data || data.ok !== true || !data.variantId) {
//       throw new Error(data?.message || 'Builder did not return a valid variantId.');
//     }

//     // Step 2: add to cart
//     i9UpdateLoading('Adding to cart…', 'Almost done.');
//     const variantGid = data.variantId || "";
//     const variantIdNum = variantGid.split("/").pop();

//     const imageUrl =
//       data?.picture ||
//       data?.i9_attributes?.image ||
//       data?.attributes?.image ||
//       data?.image ||
//       null;
//     const qty = i9GetQuantity(btn);
//     const cartData = await i9AddVariantToCart(
//       variantIdNum,
//       qty,
//       imageUrl ? { _i9_image: imageUrl } : null
//     );

//     i9UpdateLoading('Success!', 'Your headset was added to the cart.');
//     setTimeout(() => { i9HideLoading(); }, 500);
//     const hasDrawerSection = !!(cartData?.sections && cartData.sections['cart-drawer']);
//     if (!hasDrawerSection) {
//       document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
//     } else if (window.FoxTheme?.CartDrawer?.openDrawer) {
//       window.FoxTheme.CartDrawer.openDrawer();
//     }
//     if (window.FoxThemeCartHelpers?.getState) {
//       FoxThemeCartHelpers.getState().then((state) => {
//         FoxThemeCartHelpers.updateCartCount(state.item_count);
//       });
//     }

//     // Optionally refresh your cart badge / header here
//     // updateCartBadgeCount?.();
//     // refreshHeaderCartIcon?.();

//   } catch (err) {
//     console.error("Add to cart failed", err);
//     i9UpdateLoading('Something went wrong', (err && err.message) ? err.message : 'Please try again.');
//     setTimeout(() => { i9HideLoading(); }, 1200);
//     alert("Failed to add to cart. " + (err?.message || 'Please try again.'));
//   } finally {
//     btn.dataset.loading = '0';
//     btn.disabled = false;
//     btn.removeAttribute('aria-busy');
//   }
// }, true);

// function buildSenderFromMenu() {
//   const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase();
//   const style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim();
//   const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim();
//   const solidColor = document.getElementById('solid-color')?.selectedOptions[0]?.textContent.toLowerCase();

//   // Split style into top_spec / bottom_spec
//   let top_spec, bottom_spec;
//   if (style.includes('/')) {
//     [top_spec, bottom_spec] = style.split('/');
//   } else {
//     top_spec = bottom_spec = style;
//   }

//   const sender = {
//     position: position,
//     specialized: "X", // Hardcoded for now
//     bearings: "S"
//   };

//   // ----- TOP PROPERTIES -----
//   if (position === 'top' || position === 'both') {
//     sender.top_spec = top_spec;
//     sender.upper_headtube_bore = parseInt(getSelectedUpperSize());
//     sender.height = parseInt(getSelectedHeight());

//     if (colorMode === 'Solid') {
//       sender.top_cover_color = solidColor;
//       sender.top_cap_color = solidColor;
//       sender.top_cup_color = solidColor;
//     } else {
//       sender.top_cover_color = document.getElementById('top-cover-color')?.selectedOptions[0]?.textContent.toLowerCase();
//       sender.top_cap_color = document.getElementById('top-cap-color')?.selectedOptions[0]?.textContent.toLowerCase();
//       sender.top_cup_color = document.getElementById('top-cup-color')?.selectedOptions[0]?.textContent.toLowerCase();
//     }
//   }

//   // ----- BOTTOM PROPERTIES -----
//   if (position === 'bottom' || position === 'both') {
//     sender.bottom_spec = bottom_spec;
//     sender.lower_headtube_bore = parseInt(getSelectedLowerSize());

//     if (colorMode === 'Solid') {
//       sender.bottom_cup_color = solidColor;
//     } else {
//       sender.bottom_cup_color = document.getElementById('bottom-cup-color')?.selectedOptions[0]?.textContent.toLowerCase();
//     }
//   }

//   // use global encoded cfg (set by URL state script)
//   sender.menu_load = window.currentCfgEncoded || (window.i9State?.encode ? encodeURIComponent(window.i9State.encode()) : '');
//   return sender;
// }

// /* ===============================
//    I9 Headset Config: URL State Save/Restore (compact scheme)
//    =============================== */
// (function () {
//   // ---- URL-safe current cfg for easy sharing ----
//   let currentCfgEncoded = "";
//   let saveTimer = null;
//   let isRestoring = false;

//   // Expose it for your code if you want to read it
//   window.currentCfgEncoded = currentCfgEncoded;

//   // ---- compact codes (URL-friendly) ----
//   const PositionCode = { both: 'b', top: 't', bottom: 'd' };
//   const StyleCode = {
//     'ZS/ZS': 'zz', 'IS/IS': 'ii', 'EC/EC': 'ee', 'ZS/EC': 'ze',
//     'ZS': 'z', 'IS': 'i', 'EC': 'e'
//   };
//   const StyleFromCode = {
//     zz: 'ZS/ZS', ii: 'IS/IS', ee: 'EC/EC', ze: 'ZS/EC',
//     z: 'ZS', i: 'IS', e: 'EC'
//   };
//   const ColorModeCode = { Solid: 's', Custom: 'c' };
//   const ColorModeFromCode = { s: 'Solid', c: 'Custom' };

//   // ---- DOM helpers ----
//   function findOptionButton(groupName, labelText) {
//     const group = document.querySelector(`[data-group="${groupName}"] .button-group`);
//     if (!group) return null;
//     return Array.from(group.querySelectorAll('.option-button'))
//       .find(b => b.textContent.trim() === String(labelText).trim());
//   }

//   // Prefer real clicks to trigger your existing listeners (price logic etc.)
//   function clickOption(groupName, labelText) {
//     const btn = findOptionButton(groupName, labelText);
//     if (!btn) return false;
//     btn.click(); // fire your handlers
//     return true;
//   }

//   function setSelectByColorId(selectId, colorId, fireChange = true) {
//     const sel = document.getElementById(selectId);
//     if (!sel) return;
//     const opt = Array.from(sel.options).find(
//       o => (o.getAttribute('data-color') || '') == String(colorId)
//     );
//     if (opt) {
//       sel.value = opt.value;
//       if (fireChange) sel.dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   }

//   function getSelectedText(selector) {
//     return document.querySelector(selector)?.textContent.trim();
//   }

//   function getSelectedColorId(selectId) {
//     const sel = document.getElementById(selectId);
//     return sel?.selectedOptions?.[0]?.getAttribute('data-color') || '';
//   }

//   // ---- ENCODE current UI to compact "k=v;..." string ----
//   function encodeMenuState() {
//     const positionLabel = getSelectedText('[data-group="position"] .option-button.selected') || 'Both';
//     const position = positionLabel.toLowerCase();
//     let style = getSelectedText('[data-group="style"] .option-button.selected') || 'ZS/ZS';
//     const colorMode = getSelectedText('[data-group="color"] .option-button.selected') || 'Solid';

//     // normalize single styles for top/bottom
//     if (position === 'top' || position === 'bottom') {
//       if (style === 'ZS/ZS') style = 'ZS';
//       if (style === 'IS/IS') style = 'IS';
//       if (style === 'EC/EC') style = 'EC';
//     }

//     const p = PositionCode[position] || 'b';
//     const s = StyleCode[style] || 'zz';

//     // these helpers exist in your configurator JS
//     const h = (typeof getSelectedHeight === 'function' ? getSelectedHeight() : '5');
//     const u = (typeof getSelectedUpperSize === 'function' ? getSelectedUpperSize() : '44');
//     const l = (typeof getSelectedLowerSize === 'function' ? getSelectedLowerSize() : '56');

//     const c = ColorModeCode[colorMode] || 's';

//     // color IDs
//     const sc  = getSelectedColorId('solid-color') || '';
//     const tcc = getSelectedColorId('top-cap-color') || '';
//     const tvc = getSelectedColorId('top-cover-color') || '';
//     const tuc = getSelectedColorId('top-cup-color') || '';
//     const bc  = getSelectedColorId('bottom-cup-color') || '';

//     const pairs = [
//       `p=${p}`, `s=${s}`, `h=${h}`, `u=${u}`, `l=${l}`, `c=${c}`,
//       sc ? `sc=${sc}` : '',
//       tcc ? `tcc=${tcc}` : '',
//       tvc ? `tvc=${tvc}` : '',
//       tuc ? `tuc=${tuc}` : '',
//       bc ? `bc=${bc}` : ''
//     ].filter(Boolean);

//     return pairs.join(';');
//   }

//   // ---- DECODE "k=v;..." -> object (also tolerates old/new JSON by auto-detect) ----
//   function decodeMenuState(cfg) {
//     if (!cfg) return {};
//     const trimmed = cfg.trim();
//     if ((trimmed.startsWith('{') && trimmed.endsWith('}')) ||
//         (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
//       try {
//         const j = JSON.parse(trimmed);
//         const outFromJson = {};
//         if (j.pos) outFromJson.p = ({Both:'b',Top:'t',Bottom:'d'}[j.pos] || 'b');
//         if (j.style) {
//           const map = {'ZS/ZS':'zz','IS/IS':'ii','EC/EC':'ee','ZS/EC':'ze','ZS':'z','IS':'i','EC':'e'};
//           outFromJson.s = map[j.style] || 'zz';
//         }
//         if (j.tch) outFromJson.h = (j.tch.replace('mm','').trim());
//         if (j.uht) outFromJson.u = (j.uht.replace('mm','').trim());
//         if (j.lht) outFromJson.l = (j.lht.replace('mm','').trim());
//         if (j.color) outFromJson.c = ({Solid:'s',Custom:'c'}[j.color] || 's');
//         if (j.sc)  outFromJson.sc = j.sc;
//         if (j.tcc) outFromJson.tcc = j.tcc;
//         if (j.tvc) outFromJson.tvc = j.tvc;
//         if (j.tuc) outFromJson.tuc = j.tuc;
//         if (j.bc)  outFromJson.bc  = j.bc;
//         return outFromJson;
//       } catch (e) {
//         console.warn('JSON cfg parse failed, falling back to pairs:', e);
//       }
//     }
//     const out = {};
//     trimmed.split(';').forEach(pair => {
//       const [k, v] = pair.split('=');
//       if (k) out[k] = v;
//     });
//     return out;
//   }

//   function refreshColorMenusBasedOnCurrentSpec() {
//     const position = document.querySelector('[data-group="position"] .option-button.selected')?.textContent.trim().toLowerCase() || 'both';
//     const style = document.querySelector('[data-group="style"] .option-button.selected')?.textContent.trim() || 'ZS/ZS';
//     const colorMode = document.querySelector('[data-group="color"] .option-button.selected')?.textContent.trim() || 'Solid';

//     const [topSpec, bottomSpec] = style.includes('/') ? style.split('/') : [style, style];
//     const upperSize = (typeof getSelectedUpperSize === 'function' ? getSelectedUpperSize() : null);
//     const lowerSize = (typeof getSelectedLowerSize === 'function' ? getSelectedLowerSize() : null);

//     const topSpecData = i9_menu?.specs?.[topSpec];
//     const bottomSpecData = i9_menu?.specs?.[bottomSpec];

//     const show = (groupName, shouldShow) => {
//       const el = document.querySelector(`[data-group="${groupName}"]`);
//       if (el) el.style.display = shouldShow ? 'block' : 'none';
//     };

//     const isSolid = (colorMode === 'Solid');
//     const showTop = (position === 'both' || position === 'top');
//     const showBottom = (position === 'both' || position === 'bottom');

//     let hasTopCap   = !!topSpecData?.pictures?.hs_top_cap_color;
//     let hasTopCover = !!topSpecData?.pictures?.hs_top_cover_color && !!topSpecData?.heights;
//     let hasTopCup   = !!topSpecData?.pictures?.hs_top_cup_color && !!(upperSize && topSpecData?.pictures?.hs_top_cup_color?.[upperSize]);
//     let hasBottomCup= !!bottomSpecData?.pictures?.hs_bottom_cup_color && !!(lowerSize && bottomSpecData?.pictures?.hs_bottom_cup_color?.[lowerSize]);

//     show('solid color', isSolid);
//     show('top cap color',   !isSolid && showTop    && hasTopCap);
//     show('top cover color', !isSolid && showTop    && hasTopCover);
//     show('top cup color',   !isSolid && showTop    && hasTopCup);
//     show('bottom cup color',!isSolid && showBottom && hasBottomCup);
//   }

//   function waitForPriceNode(timeoutMs = 1500) {
//     return new Promise(resolve => {
//       const node = document.querySelector('[id^="Price"] .f-price-item--regular');
//       if (node) return resolve(node);
//       const obs = new MutationObserver(() => {
//         const n = document.querySelector('[id^="Price"] .f-price-item--regular');
//         if (n) { obs.disconnect(); resolve(n); }
//       });
//       obs.observe(document.documentElement, { childList: true, subtree: true });
//       setTimeout(() => { obs.disconnect(); resolve(null); }, timeoutMs);
//     });
//   }

//   async function applyMenuState(cfgStr) {
//     if (!cfgStr) return;
//     isRestoring = true;
//     const state = decodeMenuState(cfgStr);

//     // 1) Position
//     let position;
//     if (state.p === 't') position = 'Top';
//     else if (state.p === 'd') position = 'Bottom';
//     else position = 'Both';
//     clickOption('position', position);

//     if (typeof updateStyleButtonsForPosition === 'function') {
//       updateStyleButtonsForPosition(position.toLowerCase());
//     }

//     // 2) Style
//     let styleLabel = StyleFromCode[state.s || 'zz'] || 'ZS/ZS';
//     if (position !== 'Both' && styleLabel.includes('/')) {
//       styleLabel = styleLabel.split('/')[0];
//     }
//     clickOption('style', styleLabel);

//     if (typeof updateMenusForSpec === 'function') {
//       updateMenusForSpec(styleLabel, position.toLowerCase());
//     }

//     // 3) Height & bores
//     if (state.h) clickOption('top cover height', `${state.h}mm`);
//     if (state.u) clickOption('upper headtube bore', `${state.u}mm`);
//     if (state.l) clickOption('lower headtube bore', `${state.l}mm`);

//     // 4) Color mode
//     const colorMode = ColorModeFromCode[state.c || 's'] || 'Solid';
//     clickOption('color', colorMode);
//     if (typeof updateColorMenus === 'function') {
//       updateColorMenus(colorMode, position.toLowerCase());
//     }
//     refreshColorMenusBasedOnCurrentSpec();

//     // 5) Select colors by ID (fire change)
//     if (colorMode === 'Solid' && state.sc) {
//       setSelectByColorId('solid-color', state.sc, true);
//     } else if (colorMode === 'Custom') {
//       if (state.tcc) setSelectByColorId('top-cap-color', state.tcc, true);
//       if (state.tvc) setSelectByColorId('top-cover-color', state.tvc, true);
//       if (state.tuc) setSelectByColorId('top-cup-color', state.tuc, true);
//       if (state.bc)  setSelectByColorId('bottom-cup-color', state.bc, true);
//     }

//     if (typeof drawHeadsetToCanvas === 'function') drawHeadsetToCanvas();
//     await waitForPriceNode(1500);
//     if (typeof updateSelectedVariantId === 'function') updateSelectedVariantId();

//     // keep URL-ready var in sync
//     currentCfgEncoded = encodeURIComponent(cfgStr);
//     window.currentCfgEncoded = currentCfgEncoded;

//     isRestoring = false;
//   }

//   function scheduleSaveToUrl() {
//     if (isRestoring) return; // don't write URL during restore
//     clearTimeout(saveTimer);
//     saveTimer = setTimeout(() => {
//       const cfg = encodeMenuState();
//       currentCfgEncoded = encodeURIComponent(cfg); // always have URL-safe value
//       window.currentCfgEncoded = currentCfgEncoded;

//       const url = new URL(window.location.href);
//       url.searchParams.set('cfg', cfg); // let URLSearchParams encode it
//       window.history.replaceState({}, '', url.toString());
//     }, 120);
//   }

//   document.addEventListener('click', (e) => {
//     if (e.target.closest('.option-button')) {
//       scheduleSaveToUrl();
//     }
//   }, true);

//   document.addEventListener('change', (e) => {
//     if (e.target.matches('.styled-dropdown')) {
//       scheduleSaveToUrl();
//     }
//   }, true);

//   // On first load, add ?cfg=... to the URL if it is missing.
//   document.addEventListener('DOMContentLoaded', () => {
//     try {
//       const url = new URL(window.location.href);
//       const raw = url.searchParams.get('cfg');

//       if (raw) {
//         // If a cfg exists, apply it after your main init runs
//         setTimeout(() => { applyMenuState(raw); }, 0);
//         return;
//       }

//       // No cfg -> compute from current UI and add it to the URL
//       setTimeout(() => {
//         const initial = encodeMenuState();               // e.g. "p=b;s=zz;h=5;u=44;l=56;c=s;sc=14"
//         currentCfgEncoded = encodeURIComponent(initial); // store URL-safe version
//         window.currentCfgEncoded = currentCfgEncoded;    // expose globally

//         const u = new URL(window.location.href);
//         u.searchParams.set('cfg', initial);              // preserves other query params
//         window.history.replaceState({}, '', u.toString());
//       }, 0);
//     } catch (err) {
//       console.warn('State restore failed:', err);
//       isRestoring = false;
//     }
//   });

//   // ---- Minimal API for debugging / programmatic use ----
//   window.i9State = {
//     encode: () => encodeMenuState(),
//     apply: (s) => applyMenuState(s),
//     getEncoded: () => currentCfgEncoded
//   };
// })();
